//SOLO PAR LA SECCIÓN COLABORA

(function($) {

    var languageUsed = document.documentElement.lang; 
    // console.log(languageUsed); en-US es-ES
    
    var f = document.getElementsByClassName('give-form')[0];

    var formSociosParticular = $('#give-form-668-wrap');
    var formSociosEmpresa = $('#give-form-669-wrap');
    var formDonanteParticular = $('#give-form-670-wrap');
    var formDonanteEmpresa= $('#give-form-671-wrap');
    var forms = [formSociosParticular,formSociosEmpresa,formDonanteParticular,formDonanteEmpresa];

    var textIntervalSummary = null;

    var replaceSummaryOfRecurringDonations = function()
    {
        if (languageUsed !== "es-ES")
        {
            return;
        }

        var perfil = $("input[name='perfil']").val();
        if (typeof(perfil) === "undefined")
        {
            return;
        }

        var perfil_arr = perfil.split("-");
        var user = perfil_arr[0];

        if (user !== "socio")
        {
            return;
        }

        var dtag = $(".give-recurring-multi-level-message").html();
 
        dtag = dtag.replace("You have chosen to donate  <span>€</span>","Tu aportación es ");
        dtag = dtag.replace(" mensual","€ mensuales");
        dtag = dtag.replace(" every three months","€ trimestrales");
        dtag = dtag.replace(" every four months","€ cuatrimestrales");
        dtag = dtag.replace(" every six months","€ semestrales");
        dtag = dtag.replace(" yearly","€ anuales");
        dtag = dtag.replace(".00","");

        $(".give-recurring-multi-level-message").css("color","transparent");

        $(".give-recurring-multi-level-message-es").remove();

        $(".give-recurring-multi-level-message").after(function() {
          return "<p class='give-recurring-multi-level-message-es'>"+ dtag +"</p>";
        });

        var txt_es = $(".give-recurring-multi-level-message-es").html();
        var i_txt_es = txt_es.indexOf("€");
        var i_txt_es_tag = txt_es.substr(i_txt_es, 8);
        $("#recurr_donation_period").val(i_txt_es_tag);
    };

    $("#give-donation-level-select-668").change(function() {

        if (languageUsed !== "es-ES")
        {
            return;
        }

        clearInterval(textIntervalSummary);
        replaceSummaryOfRecurringDonations();
        $(".give-recurring-multi-level-message-es").html("");
        textIntervalSummary = setInterval(function(){ replaceSummaryOfRecurringDonations(); }, 2000);
    });

    $("#give-donation-level-select-669").change(function() {

        if (languageUsed !== "es-ES")
        {
            return;
        }

        clearInterval(textIntervalSummary);
        replaceSummaryOfRecurringDonations();
        $(".give-recurring-multi-level-message-es").html("");
        textIntervalSummary = setInterval(function(){ replaceSummaryOfRecurringDonations(); }, 2000);
    });

    $(".give-donation-amount input#give-amount").change(function(v) {

        if (languageUsed !== "es-ES")
        {
            return;
        }

        clearInterval(textIntervalSummary);
        replaceSummaryOfRecurringDonations();
        $(".give-recurring-multi-level-message-es").html("");
        textIntervalSummary = setInterval(function(){ replaceSummaryOfRecurringDonations(); }, 2000);
    });

    function replaceTagsOfRecurringDonations()
    {
        if (languageUsed !== "es-ES")
        {
            return;
        }

        var perfil = $("input[name='perfil']").val();
        if (typeof(perfil) === "undefined")
        {
            return;
        }

        var perfil_arr = perfil.split("-");
        var user = perfil_arr[0];
        var type = perfil_arr[1];

        if (user !== "socio")
        {
            return;
        }

        var dt;
        var form = (type === "empresa") ? "give-donation-level-select-669" : "give-donation-level-select-668" ;

        dt = $("#"+form+" option:eq(0)").html();
        dt = dt.replace("mensual","mensuales");
        $("#"+form+" option:eq(0)").html(dt);

        dt = $("#"+form+" option:eq(1)").html();
        dt = dt.replace("Every three months","trimestrales");
        $("#"+form+" option:eq(1)").html(dt);

        dt = $("#"+form+" option:eq(2)").html();
        dt = dt.replace("Every six months","semestrales");
        $("#"+form+" option:eq(2)").html(dt);

        dt = $("#"+form+" option:eq(3)").html();
        dt = dt.replace("Yearly","anuales");
        $("#"+form+" option:eq(3)").html(dt);

        // if (type === "empresa")
        // {
        //     $.each($("#ffm-metodo-pago label"), function( i, val ) {
        //       if ((i === 0) || (i === 1))
        //       {
        //         $(val).hide();
        //       }
        //     });
        // }
    }

    function isDonationForProject()
    {
        var project_destiny_ref = $("#project_destiny_ref").val();
        return ((typeof(project_destiny_ref) !== "undefined") && (project_destiny_ref !== '') && (project_destiny_ref !== null));
    }

    function getPreviousDonationParameter()
    {
        var don = $("#saveDonation_hidden").val();
        if (Number.isInteger(parseInt(don)))
        {
            var perfil = $("input[name='perfil']").val();
            if (typeof(perfil) === "undefined")
            {
                return;
            }

            var perfil_arr = perfil.split("-");
            var user = perfil_arr[0];
            var type = perfil_arr[1];

            if ((user === "donante") && (type === "particular"))
            {
                // Eliminamos pago por paypal y stripe, da error.
                // $.each($("#ffm-metodo-pago label"), function( i, val ) {
                //   if ((i === 0) || (i === 1))
                //   {
                //     $(val).hide();
                //   }
                // });

                don = don + ",00";
                don_euro = don + "€";
                $("input#give-amount").val(don);
                $("input#give-amount").attr("value", don);
                $("input#give-amount").attr("data-amount", don.replace(",00",""));
                $(".give-final-total-amount").html(don_euro);
                $(".give-final-total-amount").attr("data-total", don);

                $("input[name='give-price-id']").val("custom");

                if ((don === '10,00') || (don === '20,00') || (don === '50,00') || (don === '100,00'))
                {
                    setTimeout(function() {
                        $("#give-donation-level-button-wrap button[value='"+don+"']").trigger("click");
                    }, 2000);     
                }
            }
        }
    }

    function getProjectRefDonationParameter()
    {
        var project_destiny_ref = $("#project_destiny_ref").val();
        var project_destiny_post_id = $("#project_destiny_post_id").val();

        if ((typeof(project_destiny_ref) !== "undefined") && (project_destiny_ref !== '') && (project_destiny_ref !== null))
        {
            var perfil = $("input[name='perfil']").val();
            if (typeof(perfil) === "undefined")
            {
                return;
            }

            var perfil_arr = perfil.split("-");
            var user = perfil_arr[0];
            var type = perfil_arr[1];

            // ga('send', 'event', 'Donaciones', 'Donaciones_a_proyecto', 'Proyecto', project_destiny_ref);

            if (user === "donante")
            {
                $('#ffm-metodo-pago input:radio').last().prop('checked', true);

                $(".preselect-proyect").removeClass("hidden");

                $(".preselect-proyect-action-hide").click(function() {
                  $( ".preselect-proyect" ).toggle( "slow", function() {
                    $( ".preselect-proyect-show" ).removeClass("hidden");
                  });
                });

                $(".preselect-proyect-action-show").click(function() {
                  $( ".preselect-proyect-show" ).addClass("hidden");
                  $( ".preselect-proyect" ).toggle( "slow", function() {});
                });
            }
        }
    }

    function isMobile()
    {
        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i))
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    function moveTo(name)
    {
        $('html').animate({
         scrollTop: $(name).offset().top -200
        }, 1000);
    }

    function moveToTop()
    {
        if ($('body').scrollTop() > 0)
        {
            $('body').animate({
              scrollTop: $('.heroeForm').offset().top -200
            }, 1000);
        }
        else
        {
            if ($('html').scrollTop() > 0)
            {
                $('html').animate({
                  scrollTop: $('.heroeForm').offset().top -200
                }, 1000);
            }
        }
    }

    function removeNameErrorLabel()
    {
        $('#NameErrorLabel-label-error').remove();
        $("#give-first-name-wrap input").removeClass("error");
    }
    $("#give-first-name-wrap input").change(function() {
      removeNameErrorLabel();
    });
    function addNameErrorLabel(text)
    {
        removeNameErrorLabel();
        $('#give-first-name-wrap div.give-fl-wrap').append('<span id="NameErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $("#give-first-name-wrap input").addClass("error");
    }

    function removeSurnameErrorLabel()
    {
        $('#SurnameErrorLabel-label-error').remove();
        $("#give-last-name-wrap input").removeClass("error");
    }
    $("#give-last-name-wrap input").change(function() {
      removeSurnameErrorLabel();
    });
    function addSurnameErrorLabel(text)
    {
        removeSurnameErrorLabel();
        $('#give-last-name-wrap div.give-fl-wrap').append('<span id="SurnameErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $("#give-last-name-wrap input").addClass("error");
    }

    function removeLastSurnameErrorLabel()
    {
        $('#LastSurnameErrorLabel-label-error').remove();
        $("#donantelastname-wrap input").removeClass("error");
        $("#sociolastname-wrap input").removeClass("error");
    }
    $("#donantelastname-wrap input").change(function() {
      removeLastSurnameErrorLabel();
    });
    $("#sociolastname-wrap input").change(function() {
      removeLastSurnameErrorLabel();
    });
    function addLastSurnameErrorLabel(text)
    {
        removeLastSurnameErrorLabel();
        $('#donantelastname-wrap div.give-fl-wrap').append('<span id="LastSurnameErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $('#sociolastname-wrap div.give-fl-wrap').append('<span id="LastSurnameErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $("#donantelastname-wrap input").addClass("error");
        $("#sociolastname-wrap input").addClass("error");
    }

    function removeEmailErrorLabel()
    {
        $('#EmailErrorLabel-label-error').remove();
        $("#give-email-wrap input").removeClass("error");
    }
    $("#give-email-wrap input").change(function() {
      removeEmailErrorLabel();
    });
    function addEmailErrorLabel(text)
    {
        removeEmailErrorLabel();
        $('#give-email-wrap div.give-fl-wrap').append('<span id="EmailErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $("#give-email-wrap input").addClass("error");
    }

    function removePhoneErrorLabel()
    {
        $('#PhoneErrorLabel-label-error').remove();
        $("#donantephone-wrap input").removeClass("error");
        $("#sociophone-wrap input").removeClass("error");
    }
    $("#donantephone-wrap input").change(function() {
      removePhoneErrorLabel();
    });
    $("#sociophone-wrap input").change(function() {
      removePhoneErrorLabel();
    });
    function addPhoneErrorLabel(text)
    {
        removePhoneErrorLabel();
        $('#donantephone-wrap div.give-fl-wrap').append('<span id="PhoneErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $('#sociophone-wrap div.give-fl-wrap').append('<span id="PhoneErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $("#donantephone-wrap input").addClass("error");
        $("#sociophone-wrap input").addClass("error");
    }

    function removeDniErrorLabel()
    {
        $('#DniErrorLabel-label-error').remove();
        $("#donantedni-wrap input").removeClass("error");
        $("#sociodni-wrap input").removeClass("error");
    }
    $("#donantedni-wrap input").change(function() {
      removeDniErrorLabel();
    });
    $("#sociodni-wrap input").change(function() {
      removeDniErrorLabel();
    });
    function addDniErrorLabel(text)
    {
        removeDniErrorLabel();
        $('#donantedni-wrap div.give-fl-wrap').append('<span id="DniErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $('#sociodni-wrap div.give-fl-wrap').append('<span id="DniErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $("#donantedni-wrap input").addClass("error");
        $("#sociodni-wrap input").addClass("error");
    }

    function removeBirthdateErrorLabel()
    {
        $('#BirthdateErrorLabel-label-error').remove();
        $("#donantebirthday-wrap input").removeClass("error");
        $("#sociobirthday-wrap input").removeClass("error");
    }
    $("#donantebirthday-wrap input").change(function() {
      removeBirthdateErrorLabel();
    });
    $("#sociobirthday-wrap input").change(function() {
      removeBirthdateErrorLabel();
    });
    function addBirthdateErrorLabel(text)
    {
        removeBirthdateErrorLabel();
        $('#donantebirthday-wrap div.give-fl-wrap').append('<span id="BirthdateErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $('#sociobirthday-wrap div.give-fl-wrap').append('<span id="BirthdateErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $("#donantebirthday-wrap input").addClass("error");
        $("#sociobirthday-wrap input").addClass("error");
    }

    function removeAddressErrorLabel()
    {
        $('#AddressErrorLabel-label-error').remove();
        $("#donanteaddress-wrap input").removeClass("error");
        $("#socioaddress-wrap input").removeClass("error");
    }
    $("#donanteaddress-wrap input").change(function() {
      removeAddressErrorLabel();
    });
    $("#socioaddress-wrap input").change(function() {
      removeAddressErrorLabel();
    });
    function addAddressErrorLabel(text)
    {
        removeAddressErrorLabel();
        $('#donanteaddress-wrap div.give-fl-wrap').append('<span id="AddressErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $('#socioaddress-wrap div.give-fl-wrap').append('<span id="AddressErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $("#donanteaddress-wrap input").addClass("error");
        $("#socioaddress-wrap input").addClass("error");
    }

    function removePopulationErrorLabel()
    {
        $('#PopulationErrorLabel-label-error').remove();
        $("#sociopopulation-wrap input").removeClass("error");
        $("#donantepopulation-wrap input").removeClass("error");
        $("#poblacin-wrap input").removeClass("error");
    }
    $("#sociopopulation-wrap input").change(function() {
      removePopulationErrorLabel();
    });
    $("#donantepopulation-wrap input").change(function() {
      removePopulationErrorLabel();
    });
    $("#poblacin-wrap input").change(function() {
      removePopulationErrorLabel();
    });
    function addPopulationErrorLabel(text)
    {
        removePopulationErrorLabel();
        $('#sociopopulation-wrap div.give-fl-wrap').append('<span id="PopulationErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $('#donantepopulation-wrap div.give-fl-wrap').append('<span id="PopulationErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $('#poblacin-wrap div.give-fl-wrap').append('<span id="PopulationErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $("#sociopopulation-wrap input").addClass("error");
        $("#donantepopulation-wrap input").addClass("error");
        $("#poblacin-wrap input").addClass("error");
    }

    function removeZipcodeErrorLabel()
    {
        $('#ZipcodeErrorLabel-label-error').remove();
        $("#sociozipcode-wrap input").removeClass("error");
        $("#donantezipcode-wrap input").removeClass("error");
        $("#cp-wrap input").removeClass("error");
    }
    $("#sociozipcode-wrap input").change(function() {
      removeZipcodeErrorLabel();
    });
    $("#donantezipcode-wrap input").change(function() {
      removeZipcodeErrorLabel();
    });
    $("#cp-wrap input").change(function() {
      removeZipcodeErrorLabel();
    });
    function addZipcodeErrorLabel(text)
    {
        removeZipcodeErrorLabel();
        $('#sociozipcode-wrap div.give-fl-wrap').append('<span id="ZipcodeErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $('#donantezipcode-wrap div.give-fl-wrap').append('<span id="ZipcodeErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $('#cp-wrap div.give-fl-wrap').append('<span id="ZipcodeErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $("#sociozipcode-wrap input").addClass("error");
        $("#donantezipcode-wrap input").addClass("error");
        $("#cp-wrap input").addClass("error");
    }

    function removeProvinceErrorLabel()
    {
        $('#ProvinceErrorLabel-label-error').remove();
        $("#donantecity-wrap input").removeClass("error");
        $("#sociocity-wrap input").removeClass("error");
    }
    $("#donantecity-wrap input").change(function() {
      removeProvinceErrorLabel();
    });
    $("#sociocity-wrap input").change(function() {
      removeProvinceErrorLabel();
    });
    function addProvinceErrorLabel(text)
    {
        removeProvinceErrorLabel();
        $('#donantecity-wrap div.give-fl-wrap').append('<span id="ProvinceErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $('#sociocity-wrap div.give-fl-wrap').append('<span id="ProvinceErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $("#donantecity-wrap input").addClass("error");
        $("#sociocity-wrap input").addClass("error");
    }

    function removeCountryErrorLabel()
    {
        $('#CountryErrorLabel-label-error').remove();
        $("#donante_country-wrap input").removeClass("error");
        $("#donantecountry-wrap input").removeClass("error");
        $("#sociocountry-wrap input").removeClass("error");
    }
    $("#donante_country-wrap input").change(function() {
      removeCountryErrorLabel();
    });
    $("#donantecountry-wrap input").change(function() {
      removeCountryErrorLabel();
    });
    $("#sociocountry-wrap input").change(function() {
      removeCountryErrorLabel();
    });
    function addCountryErrorLabel(text)
    {
        removeCountryErrorLabel();
        $('#donante_country-wrap div.give-fl-wrap').append('<span id="CountryErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $('#donantecountry-wrap div.give-fl-wrap').append('<span id="CountryErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $('#sociocountry-wrap div.give-fl-wrap').append('<span id="CountryErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $("#donante_country-wrap input").addClass("error");
        $("#donantecountry-wrap input").addClass("error");
        $("#sociocountry-wrap input").addClass("error");
    }

    function removeCifErrorLabel()
    {
        $('#CifErrorLabel-label-error').remove();
        $("#cif-wrap input").removeClass("error");
    }
    $("#cif-wrap input").change(function() {
      removeCifErrorLabel();
    });
    function addCifErrorLabel(text)
    {
        removeCifErrorLabel();
        $('#cif-wrap div.give-fl-wrap').append('<span id="CifErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $("#cif-wrap input").addClass("error");
    }

    function removeContactPersonErrorLabel()
    {
        $('#ContactPersonErrorLabel-label-error').remove();
        $("#donantesurname-wrap input").removeClass("error");
    }
    $("#donantesurname-wrap input").change(function() {
      removeContactPersonErrorLabel();
    });
    function addContactPersonErrorLabel(text)
    {
        removeContactPersonErrorLabel();
        $('#donantesurname-wrap div.give-fl-wrap').append('<span id="ContactPersonErrorLabel-label-error" class="label-error"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $("#donantesurname-wrap input").addClass("error");
    }

    function removeTitularNameErrorLabel()
    {
        $('#TitularNameErrorLabel-label-error').remove();
        $("#give_purchase_form_wrap input#account-tit-name").removeClass("error");
    }
    function addTitularNameErrorLabel(text)
    {
        removeTitularNameErrorLabel();
        $('#give_purchase_form_wrap div#give_purchase_form_bank_account').append('<span id="TitularNameErrorLabel-label-error" class="label-error-tit-name"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $("#give_purchase_form_wrap input#account-tit-name").addClass("error");
    }

    function removeAccountNumberIbanErrorLabel()
    {
        $('#AccountNumberErrorLabel-label-error').remove();
        $("#give_purchase_form_wrap input#account-tit-ib-iban").removeClass("error");
        $("#give_purchase_form_wrap input#account-tit-ib-entidad").removeClass("error");
        $("#give_purchase_form_wrap input#account-tit-ib-oficina").removeClass("error");
        $("#give_purchase_form_wrap input#account-tit-ib-control").removeClass("error");
        $("#give_purchase_form_wrap input#account-tit-ib-cuenta").removeClass("error");
    }
    function addAccountNumberIbanErrorLabel(text)
    {
        removeAccountNumberIbanErrorLabel();
        $('#give_purchase_form_wrap div#give_purchase_form_bank_account').append('<span id="AccountNumberErrorLabel-label-error" class="label-error-acc-number"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $("#give_purchase_form_wrap input#account-tit-ib-iban").addClass("error");
        $("#give_purchase_form_wrap input#account-tit-ib-entidad").addClass("error");
        $("#give_purchase_form_wrap input#account-tit-ib-oficina").addClass("error");
        $("#give_purchase_form_wrap input#account-tit-ib-control").addClass("error");
        $("#give_purchase_form_wrap input#account-tit-ib-cuenta").addClass("error");
    }

    function removeAgreeTermsErrorLabel()
    {
        $('#AgreeTermsErrorLabel-label-error').remove();
        $("input[name='give_agree_to_terms']").removeClass("error");
    }
    function addAgreeTermsErrorLabel(text)
    {
        removeAgreeTermsErrorLabel();
        $('.give-submit-button-wrap').append('<span id="AgreeTermsErrorLabel-label-error" class="label-error-agreeterms"><i class="fa fa-exclamation-circle"></i>&nbsp;'+text+'</span>');
        $("input[name='give_agree_to_terms']").addClass("error");
    }

    function checkIfReloadPageInsideForm()
    {
        if ((window.location.hash === "#dataConfirmation") || (window.location.hash === "#paymentConfirmation"))
        {
            var perfil = $("input[name='perfil']").val();

            if (typeof(perfil) !== "undefined")
            {
                if (languageUsed === "es-ES")
                {
                    $('.section-colabora .panel-form-give').html("<div id='resetFormSteps'><span>Redirigiendo al comienzo del formulario, espere por favor...</span></div>");
                }
                if (languageUsed === "en-US")
                {
                    $('.section-colabora .panel-form-give').html("<div id='resetFormSteps'><span>Redirecting to the beginning of the form, please wait ...</span></div>");
                }
                
                var perfil_arr = perfil.split("-");
                var user = perfil_arr[0];
                var type = perfil_arr[1];
                var urlgo;

                if (languageUsed === "es-ES")
                {
                    if ((user === 'socio') && (type === "particular"))
                    {
                        urlgo = "socios/particular/";
                    }
                    if ((user === 'socio') && (type === "empresa"))
                    {
                        urlgo = "socios/empresa/";
                    }
                    if ((user === 'donante') && (type === "particular"))
                    {
                        urlgo = "donantes/particular/";
                    }
                    if ((user === 'donante') && (type === "empresa"))
                    {
                        urlgo = "donantes/empresa/";
                    }
                    location.href = window.location.origin + "/colabora/" + urlgo;
                }

                if (languageUsed === "en-US")
                {
                    if ((user === 'socio') && (type === "particular"))
                    {
                        urlgo = "members/individual/";
                    }
                    if ((user === 'socio') && (type === "empresa"))
                    {
                        urlgo = "members/company/";
                    }
                    if ((user === 'donante') && (type === "particular"))
                    {
                        urlgo = "donnors/individual/";
                    }
                    if ((user === 'donante') && (type === "empresa"))
                    {
                        urlgo = "donnors/company/";
                    }
                    location.href = window.location.origin + "/en/get-involved/" + urlgo;
                }
            }
        }
    }

    function setAnonimDonation()
    {
        $('#anonim-data').val("true");
        $('#next--Payment').attr("href","#paymentConfirmation");

        if (languageUsed === "es-ES")
        {
            $('#next--Payment').text(" PASO 3");
        }
        if (languageUsed === "en-US")
        {
            $('#next--Payment').text(" STEP 3");
        }

        $('.backStep2').attr("href","#");

        $('#ffm-certificado_de_donacin input:radio').last().prop('checked', true);
        $("#ffm-certificado_de_donacin input:radio").attr('disabled', true);

        var perfil = $("input[name='perfil']").val();
        if (typeof(perfil) !== "undefined")
        {
            var perfil_arr = perfil.split("-");

            if (languageUsed === "es-ES")
            {

                if (perfil_arr[1] === 'empresa')
                {
                    $('#ffm_html-wrap').html('<small>¿Quieres deducir el 35% de tu donación en la declaración de impuestos sobre sociedades? Has seleccionado que tu donación sea anónima. Para enviarte el Certificado de Donación necesitamos conocer tus datos personales.</small>');
                }
                else
                {
                    $('#ffm_html-wrap').html('<small>¿Quieres deducir el 25% de tu donación en la declaración de la renta? Has seleccionado que tu donación sea anónima. Para enviarte el Certificado de Donación necesitamos conocer tus datos personales.</small>');
                }
            }

            if (languageUsed === "en-US")
            {

                if (perfil_arr[1] === 'empresa')
                {
                    $('#ffm_html-wrap').html('<small>Do you want to deduct 35% of your donation on the corporation tax return? You have selected that your donation be anonymous. To send you the Certificate of Donation we need to know your personal data.</small>');
                }
                else
                {
                    $('#ffm_html-wrap').html('<small>Do you want to deduct 25% of your donation on the income statement? You have selected that your donation be anonymous. To send you the Certificate of Donation we need to know your personal data.</small>');
                }
            }

        }
    }

    function setNoAnonimDonation()
    {
        $('#anonim-data').val("false");
        $('#next--Payment').attr("href","#dataConfirmation");

        if (languageUsed === "es-ES")
        {
            $('#next--Payment').text(" PASO 2");
        }
        if (languageUsed === "en-US")
        {
            $('#next--Payment').text(" STEP 2");
        }

        $('.backStep2').attr("href","#dataConfirmation");

        $("#ffm-certificado_de_donacin input:radio").attr('disabled', false);

        var perfil = $("input[name='perfil']").val();
        if (typeof(perfil) !== "undefined")
        {
            var perfil_arr = perfil.split("-");

            if (languageUsed === "es-ES")
            {
                if (perfil_arr[1] === 'empresa')
                {
                    $('#ffm_html-wrap').html('<small>¿Quieres deducir el 40% de tu donación en la declaración de impuestos de sociedades? Necesitaremos tus datos y los datos de tu empresa para enviarte el certificado de donaciones (este certificado solo tiene validez en España).</small>');
                }
                else
                {
                    $('#ffm_html-wrap').html('<small>Si nos dejas tus datos personales, te podrás deducir el 75% de los primeros 150€ donados. A partir de ese importe, las donaciones serán deducibles al 30% o al 35% si se trata de donaciones periódicas realizadas durante al menos tres años (este certificado solo tiene validez en España) <a href="/actuar/desgravacion-fiscal-para-donaciones/" target="blank">Más información aquí.</a></small>');
                }
            }

            if (languageUsed === "en-US")
            {
                if (perfil_arr[1] === 'empresa')
                {
                    $('#ffm_html-wrap').html('<small>Do you want to deduct 40% of your donation on the corporate tax return? We will need your data and the data of your company to send you the certificate of donations (this certificate is only valid in Spain).</small>');
                }
                else
                {
                    $('#ffm_html-wrap').html('<small>If you leave us your personal information, you can deduct 75% of the first 150 € donated. From this amount, the donations will be deductible at 30% or at 35% if they are periodic donations made during at least three years (this certificate is only valid in Spain)</small>');
                }
            }
        }
    }

    function fillFieldsIfAnonim()
    {
        var perfil = $("input[name='perfil']").val();
        if (typeof(perfil) !== "undefined")
        {
            var perfil_arr = perfil.split("-");
            var user = perfil_arr[0];
            var type = perfil_arr[1];

            var cert = false;
            if (user === 'socio')
            {
                cert = ($('#ffm-sociocert input:radio').first().is(':checked'));
            }
            else
            {
                cert = ($('#certificado_de_donacin-wrap input:radio').first().is(':checked'));
            }

            if (user !== 'socio')
            {
                var anonim = false;
                anonim = ($('#ffm-donantetipodonacion input:radio').first().is(':checked'));
                if (anonim)
                {
                    if (type === "particular")
                    {
                        $('#give-email-wrap input').val("anonimo@codespa.org");
                        $('#give-last-name-wrap input').val("-");
                        $('#give-first-name-wrap input').val("-");
                        $('#donantebirthday-wrap input').val("-");
                        $('#donantedni-wrap input').val("-");
                        $('#donantelastname-wrap input').val("-");
                    }
                    if (type === "empresa")
                    {
                        $('#give-email-wrap input').val("anonimo@codespa.org");
                        $('#give-first-name-wrap input').val("-");
                        $('#cif-wrap input').val("-");
                        $('#donantesurname-wrap input').val("-");
                    }
                    $('#donante_country-wrap input').val("-");
                    $('#donantecountry-wrap input').val("-");
                    $('#donantecity-wrap input').val("-");
                    $('#sociozipcode-wrap input').val("-");
                    $('#donantezipcode-wrap input').val("-");
                    $('#sociopopulation-wrap input').val("-");
                    $('#donantepopulation-wrap input').val("-");
                    $('#donanteaddress-wrap input').val("-");
                    $('#donantephone-wrap input').val("-");
                }
            }
        }
    }

    function showFormInputWithGoodFeeling(name)
    {
        $('#'+name+' label').css("opacity",1);
        $('#'+name+' label').css("visibility","visible");
        $('#'+name+' input').css("padding","20px 12px 4px !important");
        $('#'+name+' input').attr("style","padding: 20px 12px 4px !important");
    }

    function showAllFormInputsWithGoodFeeling()
    {
        showFormInputWithGoodFeeling("cif-wrap");
        showFormInputWithGoodFeeling("cp-wrap");
        showFormInputWithGoodFeeling("donanteaddress-wrap");
        showFormInputWithGoodFeeling("donantebirthday-wrap");
        showFormInputWithGoodFeeling("donantecity-wrap");
        showFormInputWithGoodFeeling("donantecountry-wrap");
        showFormInputWithGoodFeeling("donantedni-wrap");
        showFormInputWithGoodFeeling("donantelastname-wrap");
        showFormInputWithGoodFeeling("donantephone-wrap");
        showFormInputWithGoodFeeling("donantepopulation-wrap");
        showFormInputWithGoodFeeling("donantesurname-wrap");
        showFormInputWithGoodFeeling("donantezipcode-wrap");
        showFormInputWithGoodFeeling("donante_country-wrap");
        showFormInputWithGoodFeeling("give-email-wrap");
        showFormInputWithGoodFeeling("give-first-name-wrap");
        showFormInputWithGoodFeeling("give-last-name-wrap");
        showFormInputWithGoodFeeling("poblacin-wrap");
        showFormInputWithGoodFeeling("socioaddress-wrap");
        showFormInputWithGoodFeeling("sociobirthday-wrap");
        showFormInputWithGoodFeeling("sociocity-wrap");
        showFormInputWithGoodFeeling("sociocountry-wrap");
        showFormInputWithGoodFeeling("sociodni-wrap");
        showFormInputWithGoodFeeling("sociolastname-wrap");
        showFormInputWithGoodFeeling("sociophone-wrap");
        showFormInputWithGoodFeeling("sociopopulation-wrap");
        showFormInputWithGoodFeeling("sociozipcode-wrap");
    }

    function resetFieldsIfNotAnonim()
    {
        $('#give-last-name-wrap input').val("");
        $('#donantebirthday-wrap input').val("");
        $('#donantedni-wrap input').val("");
        $('#donantelastname-wrap input').val("");
        $('#give-email-wrap input').val("");
        $('#give-first-name-wrap input').val("");
        $('#cif-wrap input').val("");
        $('#donantesurname-wrap input').val("");
        $('#donante_country-wrap input').val("");
        $('#donantecountry-wrap input').val("");
        $('#donantecity-wrap input').val("");
        $('#sociozipcode-wrap input').val("");
        $('#donantezipcode-wrap input').val("");
        $('#sociopopulation-wrap input').val("");
        $('#donantepopulation-wrap input').val("");
        $('#donanteaddress-wrap input').val("");
        $('#donantephone-wrap input').val("");
        $('#sociophone-wrap input').val("");
        $('#sociodni-wrap input').val("");
        $('#sociobirthday-wrap input').val("");
        $('#socioaddress-wrap input').val("");
        $('#poblacin-wrap input').val("");
        $('#cp-wrap input').val("");
        $('#socio_prefix').val("34");
        $('#ffm-sociotipovia').val("Calle");
        $('#ffm-donanteroadtype').val("Calle");
        $('#sociocity-wrap input').val("");
        $('#sociocountry-wrap input').val("");
        $('#socio_haveknown_otro-wrap textarea').val("");
        $('#donante_haveknown_otro-wrap textarea').val("");
        $("#socio_haveknown-wrap input").attr("checked",false);
        $("#donante_haveknown-wrap input").attr("checked",false);
        $("#form_helpout_howmet-wrap input").attr("checked",false);
    }

    function isBankTransfer()
    {
        return ($("#payment-method").val() === 'transfer');
    }

    function resetNumberColors()
    {
        $("div[data-linestep=1]").removeClass("linestep-selected");
        $("div[data-linestep=2]").removeClass("linestep-selected");
        $("div[data-linestep=3]").removeClass("linestep-selected");
        $("div[data-linestep=1]").removeClass("linestep-noselected");
        $("div[data-linestep=2]").removeClass("linestep-noselected");
        $("div[data-linestep=3]").removeClass("linestep-noselected");
    }

    function removeBankTransferForm()
    {
        $("#give_purchase_form_bank_account").remove();
    }

    function showBankTransferForm()
    {
        var html_form_iban_transfer;

        if (languageUsed === "es-ES")
        {
            html_form_iban_transfer = "<div id='give_purchase_form_bank_account' class='capsule'><label class='give-label'>Nombre completo del titular:</label> <span class='give-required-indicator'>*</span>";
            html_form_iban_transfer += "<input class='give-input required give-fl-input' type='text' name='account-tit-name' placeholder='Nombre completo' id='account-tit-name' value='' required='' aria-required='true'>";
            html_form_iban_transfer += "<label class='give-label'>Nº de Cuenta:</label> <span class='give-required-indicator'>*</span><br/><label class='label-aclaration'>Sólo se admiten cuentas bancarias de España</label>";
            html_form_iban_transfer += "<input class='give-input required give-fl-input account-tit-ib' type='text' name='account-tit-ib-iban' placeholder='IBAN' id='account-tit-ib-iban' value='' required='' aria-required='true'><input class='give-input required give-fl-input account-tit-ib' type='text' name='account-tit-ib-entidad' placeholder='Entidad' id='account-tit-ib-entidad' value='' required='' aria-required='true'><input class='give-input required give-fl-input account-tit-ib' type='text' name='account-tit-ib-oficina' placeholder='Oficina' id='account-tit-ib-oficina' value='' required='' aria-required='true'><input class='give-input required give-fl-input account-tit-ib' type='text' name='account-tit-ib-control' placeholder='Control' id='account-tit-ib-control' value='' required='' aria-required='true'><input class='give-input required give-fl-input account-tit-ib' type='text' name='account-tit-ib-cuenta' placeholder='Cuenta' id='account-tit-ib-cuenta' value='' required='' aria-required='true'>";
            html_form_iban_transfer += "El IBAN es un estándar internacional de identificación de cuentas bancarias creado para permitir el envío de dinero a una cuenta corriente extranjera (ej.: 'ES85').</div>";
            html_form_iban_transfer += "";
        }

        if (languageUsed === "en-US")
        {
            html_form_iban_transfer = "<div id='give_purchase_form_bank_account' class='capsule'><label class='give-label'>Full name of the owner:</label> <span class='give-required-indicator'>*</span>";
            html_form_iban_transfer += "<input class='give-input required give-fl-input' type='text' name='account-tit-name' placeholder='Full name' id='account-tit-name' value='' required='' aria-required='true'>";
            html_form_iban_transfer += "<label class='give-label'>Account number:</label> <span class='give-required-indicator'>*</span><br/><label class='label-aclaration'>Only Spain bank accounts are allowed</label>";
            html_form_iban_transfer += "<input class='give-input required give-fl-input account-tit-ib' type='text' name='account-tit-ib-iban' placeholder='IBAN' id='account-tit-ib-iban' value='' required='' aria-required='true'><input class='give-input required give-fl-input account-tit-ib' type='text' name='account-tit-ib-entidad' placeholder='Entity' id='account-tit-ib-entidad' value='' required='' aria-required='true'><input class='give-input required give-fl-input account-tit-ib' type='text' name='account-tit-ib-oficina' placeholder='Office' id='account-tit-ib-oficina' value='' required='' aria-required='true'><input class='give-input required give-fl-input account-tit-ib' type='text' name='account-tit-ib-control' placeholder='Control' id='account-tit-ib-control' value='' required='' aria-required='true'><input class='give-input required give-fl-input account-tit-ib' type='text' name='account-tit-ib-cuenta' placeholder='Account' id='account-tit-ib-cuenta' value='' required='' aria-required='true'>";
            html_form_iban_transfer += "The IBAN is an international standard for identifying bank accounts created to allow the sending of money to a foreign current account (ex.: 'ES85').</div>";
            html_form_iban_transfer += "";
        }

        $("#give_purchase_form_wrap").prepend(html_form_iban_transfer);

        $("#give_purchase_form_wrap input#account-tit-name").change(function() {
          removeTitularNameErrorLabel();
        });
        $("#give_purchase_form_wrap input#account-tit-ib-iban").change(function() {
          removeAccountNumberIbanErrorLabel();
        });
        $("#give_purchase_form_wrap input#account-tit-ib-entidad").change(function() {
          removeAccountNumberIbanErrorLabel();
        });
        $("#give_purchase_form_wrap input#account-tit-ib-oficina").change(function() {
          removeAccountNumberIbanErrorLabel();
        });
        $("#give_purchase_form_wrap input#account-tit-ib-control").change(function() {
          removeAccountNumberIbanErrorLabel();
        });
        $("#give_purchase_form_wrap input#account-tit-ib-cuenta").change(function() {
          removeAccountNumberIbanErrorLabel();
        });
    }

    function isPaypalTransfer()
    {
        return ($("#payment-method").val() === 'paypal');
    }

    function putPaypalTransfer()
    {
        $("input[name='give-gateway']").val("paypal");
    }

    function putBankTransfer()
    {
        $("input[name='give-gateway']").val("transfer");
    }

    function isStripeTransfer()
    {
        return ($("#payment-method").val() === 'stripe');
    }

    function putStripeTransfer()
    {
        $("input[name='give-gateway']").val("stripe");
    }

    function custom_add_required(id)
    {
        $("#"+id+" div label").addClass("give-fl-is-required");
        $("#"+id+" div").addClass("give-fl-is-required");
        $("#"+id+" div input").attr("required","required");
    }

    function custom_remove_required(id)
    {
        $("#"+id+" div label").removeClass("give-fl-is-required");
        $("#"+id+" div").removeClass("give-fl-is-required");
        $("#"+id+" div input").removeAttr("required");
    }

    function disablePayButton()
    {
        $("#give-purchase-button").attr("disabled", true);
    }

    function enablePayButton()
    {
        $("#give-purchase-button").attr("disabled", false);
    }

    function cleanRequiredFields(id)
    {
        custom_remove_required("give-first-name-wrap");
        custom_remove_required("give-last-name-wrap");
        custom_remove_required("sociolastname-wrap");
        custom_remove_required("give-email-wrap");
        custom_remove_required("sociophone-wrap");
        custom_remove_required("sociodni-wrap");
        custom_remove_required("sociobirthday-wrap");
        custom_remove_required("socioaddress-wrap");
        custom_remove_required("donantecity-wrap");
        custom_remove_required("donantecountry-wrap");
        custom_remove_required("poblacin-wrap");
        custom_remove_required("cp-wrap");
        custom_remove_required("donantesurname-wrap");
        custom_remove_required("cif-wrap");
    }

    function gotoStep2_noCheckAnonim()
    {
        removeTitularNameErrorLabel();
        removeAccountNumberIbanErrorLabel();
        removeAgreeTermsErrorLabel();

        removeBankTransferForm();

        $("#payment-step").val(2);

        resetNumberColors();
        $("div[data-linestep=1]").addClass("linestep-selected");
        $("div[data-linestep=2]").addClass("linestep-selected");
        $("div[data-linestep=3]").addClass("linestep-noselected");

        $("#give_purchase_form_bank_account").remove();

        moveToTop();
    }

    function gotoStep1()
    {
        removeNameErrorLabel();
        removeSurnameErrorLabel();
        removeLastSurnameErrorLabel();
        removeEmailErrorLabel();
        removePhoneErrorLabel();
        removeDniErrorLabel();
        removeBirthdateErrorLabel();
        removeAddressErrorLabel();
        removePopulationErrorLabel();
        removeZipcodeErrorLabel();
        removeProvinceErrorLabel();
        removeCountryErrorLabel();
        removeCifErrorLabel();
        removeContactPersonErrorLabel();

        removeBankTransferForm();

        cleanRequiredFields();

        resetNumberColors();
        $("div[data-linestep=1]").addClass("linestep-selected");
        $("div[data-linestep=2]").addClass("linestep-noselected");
        $("div[data-linestep=3]").addClass("linestep-noselected");

        $("#payment-step").val(1);
    }

    function enableAnonimDonation()
    {
        $("#ffm-donantetipodonacion input:radio").attr("disabled", false);
    }

    function disableAnonimDonation()
    {
        $("#ffm-donantetipodonacion input:radio").last().prop('checked', true);
        $("#ffm-donantetipodonacion input:radio").attr("disabled", true);
        setNoAnonimDonation();
    }

    function configureRequiredFields(user, type, cert)
    {
        if ((user === "socio") && (type === "particular") && (cert === true))
        {
            custom_add_required("give-first-name-wrap");
            custom_add_required("give-last-name-wrap");
            custom_add_required("sociolastname-wrap");
            custom_add_required("give-email-wrap");
            custom_add_required("sociophone-wrap");
            custom_add_required("sociodni-wrap");
            custom_add_required("sociobirthday-wrap");
            custom_add_required("socioaddress-wrap");
            custom_add_required("donantecity-wrap");
            custom_add_required("donantecountry-wrap");
            custom_add_required("poblacin-wrap");
            custom_add_required("cp-wrap");

            custom_remove_required("sociofloor-wrap");
        }

        if ((user === "socio") && (type === "particular") && (cert === false))
        {
            custom_add_required("give-first-name-wrap");
            custom_add_required("give-last-name-wrap");
            custom_add_required("sociolastname-wrap");
            custom_add_required("sociodni-wrap");
            custom_add_required("give-email-wrap");

            custom_remove_required("sociophone-wrap");
            custom_remove_required("sociobirthday-wrap");
            custom_remove_required("socioaddress-wrap");
            custom_remove_required("poblacin-wrap");
            custom_remove_required("cp-wrap");
            custom_remove_required("donantecity-wrap");
            custom_remove_required("donantecountry-wrap");
        }

        if ((user === "socio") && (type === "empresa") && (cert === true))
        {
            custom_add_required("give-first-name-wrap");
            custom_add_required("cif-wrap");
            custom_add_required("give-email-wrap");
            custom_add_required("donantesurname-wrap");
            custom_add_required("sociophone-wrap");
            custom_add_required("sociodni-wrap");
            custom_add_required("sociobirthday-wrap");
            custom_add_required("socioaddress-wrap");
            custom_add_required("sociopopulation-wrap");
            custom_add_required("sociozipcode-wrap");
            custom_add_required("sociocity-wrap");
            custom_add_required("sociocountry-wrap");

            custom_remove_required("sociofloor-wrap");
        }

        if ((user === "socio") && (type === "empresa") && (cert === false))
        {
            custom_add_required("give-first-name-wrap");
            custom_add_required("cif-wrap");
            custom_add_required("give-email-wrap");

            custom_remove_required("donantesurname-wrap");
            custom_remove_required("sociophone-wrap");
            custom_remove_required("sociobirthday-wrap");
            custom_remove_required("socioaddress-wrap");
            custom_remove_required("sociopopulation-wrap");
            custom_remove_required("sociozipcode-wrap");
            custom_remove_required("sociocity-wrap");
            custom_remove_required("sociocountry-wrap");
        }

        if ((user === "donante") && (type === "particular") && (cert === true))
        {
            custom_add_required("give-first-name-wrap");
            custom_add_required("give-last-name-wrap");
            custom_add_required("give-email-wrap");
            custom_add_required("donantelastname-wrap");
            custom_add_required("donantephone-wrap");
            custom_add_required("donantedni-wrap");
            custom_add_required("donantebirthday-wrap");
            custom_add_required("donanteaddress-wrap");
            custom_add_required("sociopopulation-wrap");
            custom_add_required("sociozipcode-wrap");
            custom_add_required("donantecity-wrap");
            custom_add_required("donante_country-wrap");

            custom_remove_required("donantefloor-wrap");
        }

        if ((user === "donante") && (type === "particular") && (cert === false))
        {
            custom_add_required("give-first-name-wrap");
            custom_add_required("give-last-name-wrap");
            custom_add_required("give-email-wrap");

            custom_remove_required("donantelastname-wrap");
            custom_remove_required("donantephone-wrap");
            custom_remove_required("donantedni-wrap");
            custom_remove_required("donantebirthday-wrap");
            custom_remove_required("donanteaddress-wrap");
            custom_remove_required("sociopopulation-wrap");
            custom_remove_required("sociozipcode-wrap");
            custom_remove_required("donantecity-wrap");
            custom_remove_required("donante_country-wrap");
        }

        if ((user === "donante") && (type === "empresa") && (cert === true))
        {
            custom_add_required("give-first-name-wrap");
            custom_add_required("give-email-wrap");
            custom_add_required("cif-wrap");
            custom_add_required("donantesurname-wrap");
            custom_add_required("donantephone-wrap");
            custom_add_required("donanteaddress-wrap");
            custom_add_required("donantepopulation-wrap");
            custom_add_required("donantezipcode-wrap");
            custom_add_required("donantecity-wrap");
            custom_add_required("donantecountry-wrap");

            custom_remove_required("donantefloor-wrap");
        }

        if ((user === "donante") && (type === "empresa") && (cert === false))
        {
            custom_add_required("give-first-name-wrap");
            custom_add_required("give-email-wrap");

            custom_remove_required("cif-wrap");
            custom_remove_required("donantesurname-wrap");
            custom_remove_required("donantephone-wrap");
            custom_remove_required("donanteaddress-wrap");
            custom_remove_required("donantepopulation-wrap");
            custom_remove_required("donantezipcode-wrap");
            custom_remove_required("donantecity-wrap");
            custom_remove_required("donantecountry-wrap");
        }
    }

    function isAnonimDonation()
    {
        return ($("#anonim-data").val() === 'true');
    }

    function goToPayment()
    {
        removeBankTransferForm();

        location.hash = '#paymentConfirmation';

        $('.step1').hide();
        $('.step2').hide();

        $('.lineSteps__bar').addClass('passed-3');
        $('.lineSteps__bar').removeClass('passed-2');

        $('*[data-lineStep="1"],*[data-lineStep="2"],*[data-lineStep="3"]').addClass('current');

        $('.step3').show();

        $("#payment-step").val(3);

        if (isBankTransfer())
        {
            showBankTransferForm();
            putBankTransfer();
        }
        if (isPaypalTransfer())
        {
            putPaypalTransfer();
        }
        if (isStripeTransfer())
        {
            putStripeTransfer();
        }

        moveToTop();
    }

    function organize()
    {
        var step1 =  $(".give-total-wrap, #give-donation-level-button-wrap, .give-recurring-donors-choice , #sociocert-wrap ,#ffm_html-wrap, #donantetipodonacion-wrap, #certificado_de_donacin-wrap, #give-payment-mode-select");
        step1.wrapAll( "<div class='step step1 row-flex row'></div>");

        var step1SubA= $('.give-donation-levels-wrap, .give-total-wrap, .give-recurring-donors-choice ');
        step1SubA.wrapAll( "<div class='col-xs-12 col-md-6 step1_a'></div>");

        var step1SubB=$('#give-payment-mode-select, #sociocert-wrap, #donantetipodonacion-wrap, #certificado_de_donacin-wrap ,#ffm_html-wrap');
        step1SubB.wrapAll( "<div class='col-xs-12  col-md-5 step1_b'></div>");

        var step2 =  $("#give_checkout_user_info, #give-ffm-section");
        step2.wrapAll( "<div id='dataConfirmation' class='step step2'></div>");

        var step3 =  $("#give_purchase_submit, #give_terms_agreement");
        step3.wrapAll( "<div id='paymentConfirmation' class='step step3'></div>");

        var blockPrefixPhone = $('#socio_prefix').parent().addClass('js-prefixPhone');
        blockPrefixPhone.prependTo('.js-phone');

        $('#give-email-wrap').addClass('form-row-last form-row-responsive').removeClass('form-row-wide');
        $('#give-ffm-section > div:first-child').insertAfter('#give-last-name-wrap').removeClass('form-row-wide give-ffm-form-row-responsive give-ffm-form-row-half').addClass('form-row form-row-first form-row-responsive ');
    
        if (languageUsed === "es-ES")
        {
            $('#give-last-name-wrap input').attr("placeholder","Primer apellido");
        }
        if (languageUsed === "en-US")
        {
            $('#give-last-name-wrap input').attr("placeholder","First surname");
        }

    }
    organize();

    (function() {

        if (languageUsed === "es-ES")
        {
            $('#give-donation-level-button-wrap').prepend('<h3>Importe</h3>');
            $('#give_checkout_user_info > legend').text('Datos de contacto');
            $('.give-payment-mode-label').text('Seleccionar método de donación');
        }
        if (languageUsed === "en-US")
        {
            $('#give-donation-level-button-wrap').prepend('<h3>Amount</h3>');
            $('#give_checkout_user_info > legend').text('Contact information');
            $('.give-payment-mode-label').text('Select donation method');
        }

        $('.give-recurring-donors-choice input[type="checkbox"]').prop('checked', true).hide();
    })();

    var typeProfile = document.getElementsByName('profile');
    var checkProfile = false;

    var newPathString;
    var currentURL;
    var pathString = window.location.pathname;

    typeProfile[0].addEventListener('click',function(){

        if (languageUsed === "es-ES")
        {
            newPathString = pathString.replace("/empresa/", "/particular/");
            currentURL = window.location.protocol + "//" + window.location.host  + newPathString;
            window.location.href = currentURL;
        }
        if (languageUsed === "en-US")
        {
            newPathString = pathString.replace("/company/", "/individual/");
            currentURL = window.location.protocol + "//" + window.location.host  + newPathString;
            window.location.href = currentURL;
        }

     });

    typeProfile[1].addEventListener('click', function(){

        if (languageUsed === "es-ES")
        {
            newPathString = pathString.replace("/particular/", "/empresa/");
            currentURL = window.location.protocol + "//" + window.location.host  + newPathString;
            window.location.href = currentURL;
        }
        if (languageUsed === "en-US")
        {
            newPathString = pathString.replace("/individual/", "/company/");
            currentURL = window.location.protocol + "//" + window.location.host  + newPathString;
            window.location.href = currentURL;
        }

    });


     (function(){

        for (var i = 0; i < typeProfile.length; i++)
        {
            typeProfile[0].checked = true;
            if (document.forms.namedItem("give-form-668-1") || document.forms.namedItem("give-form-670-1") )
            {
                typeProfile[0].checked = true;
            }
            else
            {
                typeProfile[1].checked = true;
            }
        }

     })();

    function toStep1()
    {
        removeBankTransferForm();

        removeNameErrorLabel();
        removeSurnameErrorLabel();
        removeLastSurnameErrorLabel();
        removeEmailErrorLabel();
        removePhoneErrorLabel();
        removeDniErrorLabel();
        removeBirthdateErrorLabel();
        removeAddressErrorLabel();
        removePopulationErrorLabel();
        removeZipcodeErrorLabel();
        removeProvinceErrorLabel();
        removeCountryErrorLabel();
        removeCifErrorLabel();
        removeContactPersonErrorLabel();

        $('.step1').show();
        $('.lineSteps__bar').removeClass('passed-2');
        $('.lineSteps__bar').removeClass('passed-3');
        $('*[data-lineStep="1"]').addClass('current');

        var perfil = $("input[name='perfil']").val();
        if (typeof(perfil) !== "undefined")
        {
            var perfil_arr = perfil.split("-");

            if (perfil_arr[0] === 'socio')
            {
                $(".give-recurring-multi-level-message").show();
                $(".give-recurring-multi-level-message-es").show();
            }
        }
    }

    function toStep2()
    {
        removeBankTransferForm();

        removeTitularNameErrorLabel();
        removeAccountNumberIbanErrorLabel();
        removeAgreeTermsErrorLabel();

        $('.step1').hide();
        $('.step3').hide();
        $('.lineSteps__bar').addClass('passed-2');
        $('.lineSteps__bar').removeClass('passed-3');
        $('*[data-lineStep="1"],*[data-lineStep="2"]').addClass('current');
        $('.step2').show();

        var perfil = $("input[name='perfil']").val();
        if (typeof(perfil) !== "undefined")
        {
            var perfil_arr = perfil.split("-");

            if (perfil_arr[0] === 'socio')
            {
                $(".give-recurring-multi-level-message").hide();
                clearInterval(textIntervalSummary);
                $(".give-recurring-multi-level-message-es").hide();
            }
        }
    }

    function toStep3()
    {
        $('.step1').hide();
        $('.step2').hide();
        $('.lineSteps__bar').addClass('passed-3');
        $('.lineSteps__bar').removeClass('passed-2');
        $('*[data-lineStep="1"],*[data-lineStep="2"],*[data-lineStep="3"]').addClass('current');
        $('.step3').show();

        var perfil = $("input[name='perfil']").val();
        if (typeof(perfil) !== "undefined")
        {
            var perfil_arr = perfil.split("-");

            if (perfil_arr[0] === 'socio')
            {
                $(".give-recurring-multi-level-message").hide();
                clearInterval(textIntervalSummary);
                $(".give-recurring-multi-level-message-es").hide();
            }
        }
    }

    function saveProjectDonationPossible()
    {
        var amount = $(".give-final-total-amount").attr("data-total");
        var project_destiny_ref = $("#project_destiny_ref").val();
        var project_destiny_name = $(".preselect-proyect-text-name").text();
        var donor_email = $("#give-email-wrap input").val();

        $.ajax({
           url: window.location.origin + '/wp-json/api/v1/projectdonationpossible/',
           type: "POST",
           data: {
              project_destiny_ref: project_destiny_ref,
              project_destiny_name: project_destiny_name,
              donor_email: donor_email,
              amount: amount
           },
           error: function() {
           },
           success: function(data) {
           }
        });
    }

    function isPeriodDonation()
    {
        var perfil = $("input[name='perfil']").val();
        if (typeof(perfil) !== "undefined")
        {
            var perfil_arr = perfil.split("-");
            var user = perfil_arr[0];

            if (user === 'socio')
            {
                return true;
            }
        }
        return false;
    }

    var triggerNext1, triggerBackStep1, triggerNext2;

    if (languageUsed === "es-ES")
    {
        triggerNext1 = $('<div class="col-xs-12 col-md-7 col-md-offset-5 step1_c"><a href="#dataConfirmation" id="next--Payment" class="btn btn-block btn-primary-white  d-md-block"> PASO 2</a></div>');
        triggerBackStep1 = $('<a href="#" class="btn btn-gray backStep1">VOLVER</a>');
        triggerNext2 = $('<a href="#paymentConfirmation" id="toValidate" class="btn btn-primary-white "> PASO 3</a>');
    }
    if (languageUsed === "en-US")
    {
        triggerNext1 = $('<div class="col-xs-12 col-md-7 col-md-offset-5 step1_c"><a href="#dataConfirmation" id="next--Payment" class="btn btn-block btn-primary-white  d-md-block"> STEP 2</a></div>');
        triggerBackStep1 = $('<a href="#" class="btn btn-gray backStep1">BACK</a>');
        triggerNext2 = $('<a href="#paymentConfirmation" id="toValidate" class="btn btn-primary-white "> STEP 3</a>');
    }

    triggerNext1.appendTo('.step1');
    triggerBackStep1.appendTo('.step2');
    triggerNext2.appendTo('.step2');

    var hashStep,step1,step2,step3;

    var actualizador = setInterval( function(){

        var hashStep = window.location.hash;
        var step1 = '';
        var step2 = '#dataConfirmation';
        var step3 = '#paymentConfirmation';

        if (hashStep === step2)
        {
            toStep2();
        }
        if (hashStep === step3)
        {
            toStep3();
        }
        if (hashStep === step1)
        {
            toStep1();
        }

    },100);


    (function(){

        var textThanks, textBack, textPoliticaDatos, periodicidad;

        if (languageUsed === "es-ES")
        {
            textThanks = '<p>Te recordamos que has elegido colaborar con una aportación de:</p>';
            textBack = 'Volver';
            textPoliticaDatos= '<label class="mb20"><input type="checkbox" name="give_agree_to_terms" value="1" aria-invalid="false"  required="required" data-required="yes"><span class="wpcf7-list-item-label">He leído y acepto la <a href="#" data-toggle="modal" data-target="#modal-politica-proteccion-datos" title="Leer: Política de Protección de Datos" class="color-text text-700 text-underline">Política de Protección de Datos</a></span></label>';
            periodicidad ="y con una periodicidad:";
        }
        if (languageUsed === "en-US")
        {
            textThanks = '<p>We remind you that you have chosen to collaborate with a contribution of:</p>';
            textBack = 'Back';
            textPoliticaDatos= '<label class="mb20"><input type="checkbox" name="give_agree_to_terms" value="1" aria-invalid="false"  required="required" data-required="yes"><span class="wpcf7-list-item-label">I have read and accept the <a href="#" data-toggle="modal" data-target="#modal-politica-proteccion-datos" title="Read: Data Protection Policy" class="color-text text-700 text-underline">Data Protection Policy</a></span></label>';
            periodicidad ="and with a periodicity:";
        }

        var agradecimiento = '<div class="give-form__summary" >'+ textThanks +'</div>';
        $(agradecimiento).prependTo('.step3');

        if (document.forms.namedItem("give-form-668-1") || document.forms.namedItem("give-form-669-1"))
        {
            var textPeriod = $('<p class="give-form__summary__period" >'+ periodicidad +'</p>').insertAfter( ".give-final-total-amount");
        }

        var triggerBack = $('<a href="#dataConfirmation" class="btn btn-gray backStep2 js-step">'+ textBack +'</a>');
        triggerBack.prependTo('.give-submit-button-wrap');

        var politicaDatos = $(textPoliticaDatos);
        politicaDatos.prependTo('.give-submit-button-wrap');

        $(".give-donation-total-label").text('Total');

    })();

    function validate_required(id)
    {
        var data = $("#"+id+" input").val().trim();
        if (data === '')
        {
            return false;
        }
        return true;
    }

    function validate_phone(id)
    {
        var data = $("#"+id+" input").val().trim();
        if (!/^\d{9}$/.test(data))
        {
            return false;
        }
        return true;
    }

    function validate_dni(id)
    {
        var data = $("#"+id+" input").val().trim();
        if (!/^\d{8}[A-Z]$/.test(data))
        {
            return false;
        }
        return true;
    }

    function validate_cif(id)
    {
        var data = $("#"+id+" input").val().trim();
        if (!/^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/.test(data))
        {
            return false;
        }
        return true;
    }

    function validate_email(id)
    {
        var data = $("#"+id+" input").val().toLowerCase().trim();
        if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(data))
        {
            return false;
        }
        return true;
    }

    function prepareValidation()
    {
        var perfil = $("input[name='perfil']").val();
        if (typeof(perfil) === "undefined")
        {
            return;
        }

        var perfil_arr = perfil.split("-");
        var user = perfil_arr[0];
        var type = perfil_arr[1];

        var cert = false;
        if (user === 'socio')
        {
            cert = ($('#ffm-sociocert input:radio').first().is(':checked'));
        }
        else
        {
            cert = ($('#certificado_de_donacin-wrap input:radio').first().is(':checked'));
        }

        if (type === "empresa")
        {
            if (languageUsed === "es-ES")
            {
                $('#give-first-name-wrap input').attr("placeholder","Empresa");
                $('#give-first-name-wrap label').attr("text","Empresa");
                $('#give-first-name-wrap label').html("Empresa");
                $('#cif-wrap input').attr("placeholder","CIF (Ej.: A00000000)");
                $('#cif-wrap label').attr("text","CIF (Ej.: A00000000)");
                $('#cif-wrap label').html("CIF (Ej.: A00000000)");
            }
            if (languageUsed === "en-US")
            {
                $('#give-first-name-wrap input').attr("placeholder","Company");
                $('#give-first-name-wrap label').attr("text","Company");
                $('#give-first-name-wrap label').html("Company");
                $('#cif-wrap input').attr("placeholder","CIF (Ex.: A00000000)");
                $('#cif-wrap label').attr("text","CIF (Ex.: A00000000)");
                $('#cif-wrap label').html("CIF (Ex.: A00000000)");
            }

            $('#give-last-name-wrap').hide();
            $('#cif-wrap').addClass("form-row-last");
            $('#cif-wrap').removeClass("form-row-first");
        }

        var lots_of_stuff_already_done = false;
        var triggerValidate = document.getElementById('toValidate');

        function validate(e)
        {
            if (lots_of_stuff_already_done)
            {
                lots_of_stuff_already_done = false;
                return;
            }

            e.preventDefault();

            var perfil = $("input[name='perfil']").val();
            var perfil_arr = perfil.split("-");
            var user = perfil_arr[0];
            var type = perfil_arr[1];

            var cert = false;
            if (user === 'socio')
            {
                cert = ($('#ffm-sociocert input:radio').first().is(':checked'));
            }
            else
            {
                cert = ($('#certificado_de_donacin-wrap input:radio').first().is(':checked'));
            }

            var errors = [];

            if ((user === "socio") && (type === "particular") && (cert === true))
            {
                if (!validate_required("give-first-name-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addNameErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addNameErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("give-first-name-wrap");
                }
                else
                {
                    removeNameErrorLabel();
                }

                if (!validate_required("give-last-name-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addSurnameErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addSurnameErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("give-last-name-wrap");
                }
                else
                {
                    removeSurnameErrorLabel();
                }

                if (!validate_required("sociolastname-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addLastSurnameErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addLastSurnameErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("sociolastname-wrap");
                }
                else
                {
                    removeLastSurnameErrorLabel();
                }

                if (!validate_required("give-email-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addEmailErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addEmailErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("give-email-wrap");
                }
                else if (!validate_email("give-email-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addEmailErrorLabel("FORMATO NO VÁLIDO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addEmailErrorLabel("INVALID FORMAT");
                    }
                    errors.push("give-email-wrap");
                }
                else
                {
                    removeEmailErrorLabel();
                }

                if (!validate_required("sociophone-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addPhoneErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addPhoneErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("sociophone-wrap");
                }
                else if (!validate_phone("sociophone-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addPhoneErrorLabel("Formato Inválido. El formato debe ser 910000000");
                    }
                    if (languageUsed === "en-US")
                    {
                        addPhoneErrorLabel("Invalid format. The format should be 910000000");
                    }
                    errors.push("sociophone-wrap");
                }
                else
                {
                    removePhoneErrorLabel();
                }

                if (!validate_required("sociodni-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addDniErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addDniErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("sociodni-wrap");
                }
                else if (!validate_dni("sociodni-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addDniErrorLabel("Formato Inválido. El formato debe ser 00000001X");
                    }
                    if (languageUsed === "en-US")
                    {
                        addDniErrorLabel("Invalid format. The format should be 00000001X");
                    }
                    errors.push("sociodni-wrap");
                }
                else
                {
                    removeDniErrorLabel();
                }

                if (!validate_required("sociobirthday-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addBirthdateErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addBirthdateErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("sociobirthday-wrap");
                }
                else
                {
                    removeBirthdateErrorLabel();
                }

                if (!validate_required("socioaddress-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addAddressErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addAddressErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("socioaddress-wrap");
                }
                else
                {
                    removeAddressErrorLabel();
                }

                if (!validate_required("donantecity-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addProvinceErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addProvinceErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("donantecity-wrap");
                }
                else
                {
                    removeProvinceErrorLabel();
                }

                if (!validate_required("donantecountry-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addCountryErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addCountryErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("donantecountry-wrap");
                }
                else
                {
                    removeCountryErrorLabel();
                }

                if (!validate_required("poblacin-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addPopulationErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addPopulationErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("poblacin-wrap");
                }
                else
                {
                    removePopulationErrorLabel();
                }

                if (!validate_required("cp-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addZipcodeErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addZipcodeErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("cp-wrap");
                }
                else
                {
                    removeZipcodeErrorLabel();
                }
            }

            if ((user === "socio") && (type === "particular") && (cert === false))
            {
                if (!validate_required("give-first-name-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addNameErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addNameErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("give-first-name-wrap");
                }
                else
                {
                    removeNameErrorLabel();
                }

                if (!validate_required("give-last-name-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addSurnameErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addSurnameErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("give-last-name-wrap");
                }
                else
                {
                    removeSurnameErrorLabel();
                }

                if (!validate_required("sociolastname-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addLastSurnameErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addLastSurnameErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("sociolastname-wrap");
                }
                else
                {
                    removeLastSurnameErrorLabel();
                }

                if (!validate_required("give-email-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addEmailErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addEmailErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("give-email-wrap");
                }
                else if (!validate_email("give-email-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addEmailErrorLabel("FORMATO NO VÁLIDO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addEmailErrorLabel("INVALID FORMAT");
                    }
                    errors.push("give-email-wrap");
                }
                else
                {
                    removeEmailErrorLabel();
                }

                if (!validate_required("sociodni-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addDniErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addDniErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("sociodni-wrap");
                }
                else if (!validate_dni("sociodni-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addDniErrorLabel("Formato Inválido. El formato debe ser 00000001X");
                    }
                    if (languageUsed === "en-US")
                    {
                        addDniErrorLabel("Invalid format. The format should be 00000001X");
                    }
                    errors.push("sociodni-wrap");
                }
                else
                {
                    removeDniErrorLabel();
                }

                removePhoneErrorLabel();
                removeBirthdateErrorLabel();
                removeAddressErrorLabel();
                removeProvinceErrorLabel();
                removeCountryErrorLabel();
                removePopulationErrorLabel();
                removeZipcodeErrorLabel();
            }

            if ((user === "socio") && (type === "empresa") && (cert === true))
            {
                if (!validate_required("give-first-name-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addNameErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addNameErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("give-first-name-wrap");
                }
                else
                {
                    removeNameErrorLabel();
                }

                if (!validate_required("cif-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addCifErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addCifErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("cif-wrap");
                }
                else if (!validate_cif("cif-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addCifErrorLabel("FORMATO NO VÁLIDO. El formato debe ser A00000000");
                    }
                    if (languageUsed === "en-US")
                    {
                        addCifErrorLabel("Invalid format. The format should be A00000000");
                    }
                    errors.push("give-email-wrap");
                }
                else
                {
                    removeCifErrorLabel();
                }

                if (!validate_required("give-email-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addEmailErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addEmailErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("give-email-wrap");
                }
                else if (!validate_email("give-email-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addEmailErrorLabel("FORMATO NO VÁLIDO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addEmailErrorLabel("INVALID FORMAT");
                    }
                    errors.push("give-email-wrap");
                }
                else
                {
                    removeEmailErrorLabel();
                }

                if (!validate_required("sociophone-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addPhoneErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addPhoneErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("sociophone-wrap");
                }
                else if (!validate_phone("sociophone-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addPhoneErrorLabel("Formato Inválido. El formato debe ser 910000000");
                    }
                    if (languageUsed === "en-US")
                    {
                        addPhoneErrorLabel("Invalid format. The format should be 910000000");
                    }
                    errors.push("sociophone-wrap");
                }
                else
                {
                    removePhoneErrorLabel();
                }

                if (!validate_required("sociocountry-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addCountryErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addCountryErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("sociocountry-wrap");
                }
                else
                {
                    removeCountryErrorLabel();
                }

                if (!validate_required("sociocity-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addProvinceErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addProvinceErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("sociocity-wrap");
                }
                else
                {
                    removeProvinceErrorLabel();
                }

                if (!validate_required("sociozipcode-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addZipcodeErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addZipcodeErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("sociozipcode-wrap");
                }
                else
                {
                    removeZipcodeErrorLabel();
                }

                if (!validate_required("sociopopulation-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addPopulationErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addPopulationErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("sociopopulation-wrap");
                }
                else
                {
                    removePopulationErrorLabel();
                }

                if (!validate_required("socioaddress-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addAddressErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addAddressErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("socioaddress-wrap");
                }
                else
                {
                    removeAddressErrorLabel();
                }

                if (!validate_required("donantesurname-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addContactPersonErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addContactPersonErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("donantesurname-wrap");
                }
                else
                {
                    removeContactPersonErrorLabel();
                }
            }

            if ((user === "socio") && (type === "empresa") && (cert === false))
            {
                if (!validate_required("give-first-name-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addNameErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addNameErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("give-first-name-wrap");
                }
                else
                {
                    removeNameErrorLabel();
                }

                if (!validate_required("cif-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addCifErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addCifErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("cif-wrap");
                }
                else if (!validate_cif("cif-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addCifErrorLabel("FORMATO NO VÁLIDO. El formato debe ser A00000000");
                    }
                    if (languageUsed === "en-US")
                    {
                        addCifErrorLabel("Invalid format. The format should be A00000000");
                    }
                    errors.push("give-email-wrap");
                }
                else
                {
                    removeCifErrorLabel();
                }

                if (!validate_required("give-email-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addEmailErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addEmailErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("give-email-wrap");
                }
                else if (!validate_email("give-email-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addEmailErrorLabel("FORMATO NO VÁLIDO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addEmailErrorLabel("INVALID FORMAT");
                    }
                    errors.push("give-email-wrap");
                }
                else
                {
                    removeEmailErrorLabel();
                }

                removePhoneErrorLabel();
                removeCountryErrorLabel();
                removeProvinceErrorLabel();
                removeZipcodeErrorLabel();
                removePopulationErrorLabel();
                removeAddressErrorLabel();
                removeContactPersonErrorLabel();
            }

            var anonim = false;
            if (user === "donante")
            {
                anonim = ($('#ffm-donantetipodonacion input:radio').first().is(':checked'));
            }

            if ((user === "donante") && (type === "particular") && (cert === true))
            {
                if (!validate_required("give-first-name-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addNameErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addNameErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("give-first-name-wrap");
                }
                else
                {
                    removeNameErrorLabel();
                }

                if (!validate_required("give-last-name-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addSurnameErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addSurnameErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("give-last-name-wrap");
                }
                else
                {
                    removeSurnameErrorLabel();
                }

                if (!validate_required("give-email-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addEmailErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addEmailErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("give-email-wrap");
                }
                else if (!validate_email("give-email-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addEmailErrorLabel("FORMATO NO VÁLIDO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addEmailErrorLabel("INVALID FORMAT");
                    }
                    errors.push("give-email-wrap");
                }
                else
                {
                    removeEmailErrorLabel();
                }

                if (!validate_required("donantelastname-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addLastSurnameErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addLastSurnameErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("donantelastname-wrap");
                }
                else
                {
                    removeLastSurnameErrorLabel();
                }

                if (!validate_required("donantephone-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addPhoneErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addPhoneErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("donantephone-wrap");
                }
                else if (!validate_phone("donantephone-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addPhoneErrorLabel("Formato Inválido. El formato debe ser 910000000");
                    }
                    if (languageUsed === "en-US")
                    {
                        addPhoneErrorLabel("Invalid format. The format should be 910000000");
                    }
                    errors.push("donantephone-wrap");
                }
                else
                {
                    removePhoneErrorLabel();
                }

                if (!validate_required("donantedni-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addDniErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addDniErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("donantedni-wrap");
                }
                else if (!validate_dni("donantedni-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addDniErrorLabel("Formato Inválido. El formato debe ser 00000001X");
                    }
                    if (languageUsed === "en-US")
                    {
                        addDniErrorLabel("Invalid format. The format should be 00000001X");
                    }
                    errors.push("donantedni-wrap");
                }
                else
                {
                    removeDniErrorLabel();
                }

                if (!validate_required("donantebirthday-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addBirthdateErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addBirthdateErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("donantebirthday-wrap");
                }
                else
                {
                    removeBirthdateErrorLabel();
                }

                if (!validate_required("donanteaddress-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addAddressErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addAddressErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("donanteaddress-wrap");
                }
                else
                {
                    removeAddressErrorLabel();
                }

                if (!validate_required("sociopopulation-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addPopulationErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addPopulationErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("sociopopulation-wrap");
                }
                else
                {
                    removePopulationErrorLabel();
                }

                if (!validate_required("sociozipcode-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addZipcodeErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addZipcodeErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("sociozipcode-wrap");
                }
                else
                {
                    removeZipcodeErrorLabel();
                }

                if (!validate_required("donantecity-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addProvinceErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addProvinceErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("donantecity-wrap");
                }
                else
                {
                    removeProvinceErrorLabel();
                }

                if (!validate_required("donante_country-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addCountryErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addCountryErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("donante_country-wrap");
                }
                else
                {
                    removeCountryErrorLabel();
                }
            }

            if ((user === "donante") && (type === "particular") && (cert === false))
            {
                if (!anonim)
                {
                    if (!validate_required("give-first-name-wrap"))
                    {
                        if (languageUsed === "es-ES")
                        {
                            addNameErrorLabel("CAMPO OBLIGATORIO");
                        }
                        if (languageUsed === "en-US")
                        {
                            addNameErrorLabel("OBLIGATORY FIELD");
                        }
                        errors.push("give-first-name-wrap");
                    }
                    else
                    {
                        removeNameErrorLabel();
                    }

                    if (!validate_required("give-last-name-wrap"))
                    {
                        if (languageUsed === "es-ES")
                        {
                            addSurnameErrorLabel("CAMPO OBLIGATORIO");
                        }
                        if (languageUsed === "en-US")
                        {
                            addSurnameErrorLabel("OBLIGATORY FIELD");
                        }
                        errors.push("give-last-name-wrap");
                    }
                    else
                    {
                        removeSurnameErrorLabel();
                    }

                    if (!validate_required("give-email-wrap"))
                    {
                        if (languageUsed === "es-ES")
                        {
                            addEmailErrorLabel("CAMPO OBLIGATORIO");
                        }
                        if (languageUsed === "en-US")
                        {
                            addEmailErrorLabel("OBLIGATORY FIELD");
                        }
                        errors.push("give-email-wrap");
                    }
                    else if (!validate_email("give-email-wrap"))
                    {
                        if (languageUsed === "es-ES")
                        {
                            addEmailErrorLabel("FORMATO NO VÁLIDO");
                        }
                        if (languageUsed === "en-US")
                        {
                            addEmailErrorLabel("INVALID FORMAT");
                        }
                        errors.push("give-email-wrap");
                    }
                    else
                    {
                        removeEmailErrorLabel();
                    }

                    removeLastSurnameErrorLabel();
                    removePhoneErrorLabel();
                    removeDniErrorLabel();
                    removeBirthdateErrorLabel();
                    removeAddressErrorLabel();
                    removePopulationErrorLabel();
                    removeZipcodeErrorLabel();
                    removeProvinceErrorLabel();
                    removeCountryErrorLabel();
                }
            }

            if ((user === "donante") && (type === "empresa") && (cert === true))
            {
                if (!validate_required("give-first-name-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addNameErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addNameErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("give-first-name-wrap");
                }
                else
                {
                    removeNameErrorLabel();
                }

                if (!validate_required("cif-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addCifErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addCifErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("cif-wrap");
                }
                else if (!validate_cif("cif-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addCifErrorLabel("FORMATO NO VÁLIDO. El formato debe ser A00000000");
                    }
                    if (languageUsed === "en-US")
                    {
                        addCifErrorLabel("Invalid format. The format should be A00000000");
                    }
                    errors.push("give-email-wrap");
                }
                else
                {
                    removeCifErrorLabel();
                }

                if (!validate_required("give-email-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addEmailErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addEmailErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("give-email-wrap");
                }
                else if (!validate_email("give-email-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addEmailErrorLabel("FORMATO NO VÁLIDO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addEmailErrorLabel("INVALID FORMAT");
                    }
                    errors.push("give-email-wrap");
                }
                else
                {
                    removeEmailErrorLabel();
                }

                if (!validate_required("donantephone-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addPhoneErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addPhoneErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("donantephone-wrap");
                }
                else if (!validate_phone("donantephone-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addPhoneErrorLabel("Formato Inválido. El formato debe ser 910000000");
                    }
                    if (languageUsed === "en-US")
                    {
                        addPhoneErrorLabel("Invalid format. The format should be 910000000");
                    }
                    errors.push("donantephone-wrap");
                }
                else
                {
                    removePhoneErrorLabel();
                }

                if (!validate_required("donantecountry-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addCountryErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addCountryErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("donantecountry-wrap");
                }
                else
                {
                    removeCountryErrorLabel();
                }

                if (!validate_required("donantecity-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addProvinceErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addProvinceErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("donantecity-wrap");
                }
                else
                {
                    removeProvinceErrorLabel();
                }

                if (!validate_required("donantezipcode-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addZipcodeErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addZipcodeErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("donantezipcode-wrap");
                }
                else
                {
                    removeZipcodeErrorLabel();
                }

                if (!validate_required("donantepopulation-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addPopulationErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addPopulationErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("donantepopulation-wrap");
                }
                else
                {
                    removePopulationErrorLabel();
                }

                if (!validate_required("donanteaddress-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addAddressErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addAddressErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("donanteaddress-wrap");
                }
                else
                {
                    removeAddressErrorLabel();
                }

                if (!validate_required("donantesurname-wrap"))
                {
                    if (languageUsed === "es-ES")
                    {
                        addContactPersonErrorLabel("CAMPO OBLIGATORIO");
                    }
                    if (languageUsed === "en-US")
                    {
                        addContactPersonErrorLabel("OBLIGATORY FIELD");
                    }
                    errors.push("donantesurname-wrap");
                }
                else
                {
                    removeContactPersonErrorLabel();
                }
            }

            if ((user === "donante") && (type === "empresa") && (cert === false))
            {
                if (!anonim)
                {
                    if (!validate_required("give-first-name-wrap"))
                    {
                        if (languageUsed === "es-ES")
                        {
                            addNameErrorLabel("CAMPO OBLIGATORIO");
                        }
                        if (languageUsed === "en-US")
                        {
                            addNameErrorLabel("OBLIGATORY FIELD");
                        }
                        errors.push("give-first-name-wrap");
                    }
                    else
                    {
                        removeNameErrorLabel();
                    }

                    if (!validate_required("give-email-wrap"))
                    {
                        if (languageUsed === "es-ES")
                        {
                            addEmailErrorLabel("CAMPO OBLIGATORIO");
                        }
                        if (languageUsed === "en-US")
                        {
                            addEmailErrorLabel("OBLIGATORY FIELD");
                        }
                        errors.push("give-email-wrap");
                    }
                    else if (!validate_email("give-email-wrap"))
                    {
                        if (languageUsed === "es-ES")
                        {
                            addEmailErrorLabel("FORMATO NO VÁLIDO");
                        }
                        if (languageUsed === "en-US")
                        {
                            addEmailErrorLabel("INVALID FORMAT");
                        }
                        errors.push("give-email-wrap");
                    }
                    else
                    {
                        removeEmailErrorLabel();
                    }

                    removeCifErrorLabel();
                    removePhoneErrorLabel();
                    removeCountryErrorLabel();
                    removeProvinceErrorLabel();
                    removeZipcodeErrorLabel();
                    removePopulationErrorLabel();
                    removeAddressErrorLabel();
                    removeContactPersonErrorLabel();
                }
            }

            if (errors.length > 0)
            {
                errors = [];
                moveToTop();
                return false;
            }

            // Success!

            var anonim_s = false;
            var payment_method = "stripe";
            if (user === "donante")
            {
                anonim_s = ($('#ffm-donantetipodonacion input:radio').first().is(':checked'));
                if ($("#radio_metodopago_transfer").is(':checked')) {
                    payment_method = "transfer";
                }
                if ($("#radio_metodopago_paypal").is(':checked')) {
                    payment_method = "paypal";
                }
            }
            else
            {
                payment_method = "transfer";
            }
            if (!anonim_s)
            {
                ga('send', 'event', 'Donaciones', 'Formulario_donaciones', 'Paso_2_' + user + '_' + type + '_usuario_' + payment_method);
            }
            else
            {
                ga('send', 'event', 'Donaciones', 'Formulario_donaciones', 'Paso_2_' + user + '_' + type + '_usuarioAnonimo_' + payment_method);
            }


            $("#payment-step").val(3);
            location.hash = '#paymentConfirmation';

            resetNumberColors();
            $("div[data-linestep=1]").addClass("linestep-selected");
            $("div[data-linestep=2]").addClass("linestep-selected");
            $("div[data-linestep=3]").addClass("linestep-selected");

            if (isPeriodDonation())
            {
                var period = $("#recurr_donation_period").val();
                var text_period;

                if (languageUsed === "es-ES")
                {
                    text_period = "mensual";
                    switch(period) {
                        case "€ mensua":
                            text_period = "mensual";
                            break;
                        case "€ anuale":
                            text_period = "anual";
                            break;
                        case "€ trimes":
                            text_period = "trimestral";
                            break;
                        case "€ cuatri":
                            text_period = "cuatrimestral";
                            break;
                        case "€ semest":
                            text_period = "semestral";
                            break;
                        default:
                            text_period = "mensual";
                    }
                }
                if (languageUsed === "en-US")
                {
                    text_period = "monthly";

                    var txt_en = $(".give-recurring-multi-level-message").html();
                    var i_txt_en = txt_en.indexOf("amount");
                    var i_txt_en_tag = txt_en.substr(i_txt_en + 21);

                    switch(i_txt_en_tag) {

                        case "monthly":
                            text_period = "monthly";
                            break;
                        case "every three months.":
                            text_period = "every three months";
                            break;
                        case "every four months.":
                            text_period = "every four months";
                            break;
                        case "every six months.":
                            text_period = "every six months";
                            break;
                        case "yearly.":
                            text_period = "yearly";
                            break;

                        case " yearly.":
                            text_period = "yearly";
                            break;

                        case "n> monthly.":
                            text_period = "monthly";
                            break;
                        case "n> every three months.":
                            text_period = "every three months";
                            break;
                        case "n> every four months.":
                            text_period = "every four months";
                            break;
                        case "n> every six months.":
                            text_period = "every six months";
                            break;
                        case "n> yearly.":
                            text_period = "yearly";
                            break;

                        case "> monthly.":
                            text_period = "monthly";
                            break;
                        case "> every three months.":
                            text_period = "every three months";
                            break;
                        case "> every four months.":
                            text_period = "every four months";
                            break;
                        case "> every six months.":
                            text_period = "every six months";
                            break;
                        case "> yearly.":
                            text_period = "yearly";
                            break;

                        case "an> monthly.":
                            text_period = "monthly";
                            break;
                        case "an> every three months.":
                            text_period = "every three months";
                            break;
                        case "an> every four months.":
                            text_period = "every four months";
                            break;
                        case "an> every six months.":
                            text_period = "every six months";
                            break;
                        case "an> yearly.":
                            text_period = "yearly";
                            break;

                        case "pan> monthly.":
                            text_period = "monthly";
                            break;
                        case "pan> every three months.":
                            text_period = "every three months";
                            break;
                        case "pan> every four months.":
                            text_period = "every four months";
                            break;
                        case "pan> every six months.":
                            text_period = "every six months";
                            break;
                        case "pan> yearly.":
                            text_period = "yearly";
                            break;

                        case "span> monthly.":
                            text_period = "monthly";
                            break;
                        case "span> every three months.":
                            text_period = "every three months";
                            break;
                        case "span> every four months.":
                            text_period = "every four months";
                            break;
                        case "span> every six months.":
                            text_period = "every six months";
                            break;
                        case "span> yearly.":
                            text_period = "yearly";
                            break;

                        default:
                            text_period = "monthly";
                    }
                }

                $("#give-recurring-modal-period").html(text_period);
            }

            if (isBankTransfer())
            {
                showBankTransferForm();
                putBankTransfer();
            }
            if (isPaypalTransfer())
            {
                putPaypalTransfer();
            }
            if (isStripeTransfer())
            {
                putStripeTransfer();
            }

            moveToTop();
        }

        triggerValidate.addEventListener('click', validate);
        $('.lineSteps__triggers--3').on('click', validate);
    }

    $('.lineSteps__triggers--2').on('click', gotoStep2_noCheckAnonim);
    $('.lineSteps__triggers--1').on('click', gotoStep1);

    function showAjaxError()
    {
        enablePayButton();
        $(".give-loading-animation").hide();

        if (languageUsed === "es-ES")
        {
            alert('Hubo algún error al procesar la información y la donación no fue registrada, por favor pruebe más tarde.');
        }
        if (languageUsed === "en-US")
        {
            alert('There was some error in processing the information and the donation was not registered, please try later.');
        }
                        
        checkIfReloadPageInsideForm();
    }

    function payBankTransfer()
    {
        var perfil = $("input[name='perfil']").val();
        if (typeof(perfil) !== "undefined")
        {
            var perfil_arr = perfil.split("-");
            var user = perfil_arr[0];
            var type = perfil_arr[1];

            var cert = false;
            if (user === 'socio')
            {
                cert = ($('#ffm-sociocert input:radio').first().is(':checked'));
            }
            else
            {
                cert = ($('#certificado_de_donacin-wrap input:radio').first().is(':checked'));
            }

            var anonim = false;
            if (user === "donante")
            {
                anonim = ($('#ffm-donantetipodonacion input:radio').first().is(':checked'));
            }

            var project_destiny_ref = $("#project_destiny_ref").val();
            var project_destiny_post_id = $("#project_destiny_post_id").val();
            var project_destiny_name = "";
            if ((typeof(project_destiny_ref) !== "undefined") && (project_destiny_ref !== '') && (project_destiny_ref !== null))
            {
                project_destiny_name = $(".preselect-proyect-text-name").html();
            }

            var donantedni, donantebirthday, donanteaddress, sociopopulation, sociozipcode, donante_country, donante_haveknown, payment_bt_cuenta;
            var donante_haveknown_otro, donantephone, donanteroadtype, donantetipodonacion, give_recurring_modal_period, _give_payment_total, _give_payment_currency;
            var _give_donor_billing_first_name, _give_donor_billing_last_name, _give_payment_gateway, _give_payment_price_id, _give_payment_donor_email, donantesurname;
            var _give_payment_mode, _give_current_url, _give_current_page_id, _give_tributes_accept, certificado_de_donacin, donantelastname, donantecity;
            var _give_form_fields_id, _give_payment_form_title, payment_bt_complete_name, payment_bt_iban, payment_bt_entidad, payment_bt_oficina, payment_bt_control;
            var sociodni, sociophone, sociolastname, sociobirthday, sociotipovia, socioaddress, poblacin, cp, donantecountry, socio_haveknown_otro;

            if ((user === 'socio') && (type === "particular"))
            {
                sociodni = $("#sociodni-wrap input").val();
                sociobirthday = $("#sociobirthday-wrap input").val();
                socioaddress = $("#socioaddress-wrap input").val();
                poblacin = $("#poblacin-wrap input").val();
                cp = $("#cp-wrap input").val();
                donantecountry = $("#donantecountry-wrap input").val();
                donante_haveknown = $("#form_helpout_howmet-wrap input:checked").val();
                socio_haveknown_otro = $("#ffm-socio_haveknown_otro").val();
                sociophone = $("#sociophone-wrap select option:selected").text() + $("#sociophone-wrap input").val();
                sociotipovia = $("#sociotipovia-wrap select option:selected").text();
                donantetipodonacion = "No tengo problema en facilitar mis datos";
                give_recurring_modal_period = $("#give-recurring-modal-period").html();
                _give_payment_total = $(".give-final-total-amount").html().trim().replace("€","");
                _give_payment_currency = "EUR";
                _give_donor_billing_first_name = $("#give-first-name-wrap input").val();
                _give_donor_billing_last_name = $("#give-last-name-wrap input").val();
                _give_payment_gateway = $("input[name='give-gateway']").val() + " " + give_recurring_modal_period;
                _give_payment_price_id = "0";
                _give_payment_donor_email = $("#give-email-wrap input").val();
                _give_payment_mode = "live";
                _give_current_url = window.location.origin + "/colabora/";
                _give_current_page_id = "867";
                _give_tributes_accept = "";
                certificado_de_donacin = (cert) ? "SÍ" : "NO" ;
                sociolastname = $("#give-last-name-wrap input").val();
                donantecity = $("#donantecity-wrap input").val();
                _give_form_fields_id = "";
                _give_payment_form_title = "";
                payment_bt_complete_name = $("#account-tit-name").val();
                payment_bt_iban = $("#account-tit-ib-iban").val();
                payment_bt_entidad = $("#account-tit-ib-entidad").val();
                payment_bt_oficina = $("#account-tit-ib-oficina").val();
                payment_bt_control = $("#account-tit-ib-control").val();
                payment_bt_cuenta = $("#account-tit-ib-cuenta").val();
                _give_form_fields_id = "668";
                _give_payment_form_title = "Socio particular";
                _give_current_url += "socios/particular/";

                $.ajax({
                   url: window.location.origin + '/wp-json/api/v1/bankpayment/',
                   type: "POST",
                   data: {
                      tipo_user: user,
                      tipo_medio: type,
                      _give_payment_total: _give_payment_total,
                      _give_payment_currency: _give_payment_currency,
                      _give_donor_billing_first_name: _give_donor_billing_first_name,
                      _give_donor_billing_last_name: _give_donor_billing_last_name,
                      _give_payment_gateway: _give_payment_gateway,
                      _give_payment_form_title: _give_payment_form_title,
                      _give_payment_form_id: _give_form_fields_id,
                      _give_payment_price_id: _give_payment_price_id,
                      _give_payment_donor_email: _give_payment_donor_email,
                      _give_payment_mode: _give_payment_mode,
                      _give_current_url: _give_current_url,
                      _give_current_page_id: _give_current_page_id,
                      _give_tributes_accept: _give_tributes_accept,
                      donantetipodonacion: donantetipodonacion,
                      certificado_de_donacin: certificado_de_donacin,
                      sociolastname: sociolastname,
                      sociophone: sociophone,
                      sociodni: sociodni,
                      sociobirthday: sociobirthday,
                      sociotipovia: sociotipovia,
                      socioaddress: socioaddress,
                      poblacin: poblacin,
                      cp: cp,
                      donantecity: donantecity,
                      donantecountry: donantecountry,
                      donante_haveknown: donante_haveknown,
                      socio_haveknown_otro: socio_haveknown_otro,
                      perfil: perfil,
                      _give_form_fields_id: _give_form_fields_id,
                      payment_bt_complete_name: payment_bt_complete_name,
                      payment_bt_iban: payment_bt_iban,
                      payment_bt_entidad: payment_bt_entidad,
                      payment_bt_oficina: payment_bt_oficina,
                      payment_bt_control: payment_bt_control,
                      payment_bt_cuenta: payment_bt_cuenta,
                      lang: languageUsed
                   },
                   error: function() {
                        showAjaxError();
                   },
                   success: function(data) {
                        if (languageUsed === "es-ES")
                        {
                            location.href = window.location.origin + "/colabora/confirmacion-de-donacion/";
                        }
                        if (languageUsed === "en-US")
                        {
                            location.href = window.location.origin + "/get-involved/donation-confirmation/";
                        }
                   }
                });

            }

            if ((user === 'socio') && (type === "empresa"))
            {
                sociopopulation = $("#sociopopulation-wrap input").val();
                socioaddress = $("#socioaddress-wrap input").val();
                sociozipcode = $("#sociozipcode-wrap input").val();
                sociocountry = $("#sociocountry-wrap input").val();
                socio_haveknown = $("#socio_haveknown-wrap input:checked").val();
                socio_haveknown_otro = $("#ffm-socio_haveknown_otro").val();
                sociophone = $("#sociophone-wrap select option:selected").text() + $("#sociophone-wrap input").val();
                sociotipovia = $("#sociotipovia-wrap select option:selected").text();
                donantetipodonacion = "No tengo problema en facilitar mis datos";
                give_recurring_modal_period = $("#give-recurring-modal-period").html();
                _give_payment_total = $(".give-final-total-amount").html().trim().replace("€","");
                _give_payment_currency = "EUR";
                _give_donor_billing_first_name = $("#give-first-name-wrap input").val();
                _give_donor_billing_last_name = $("#give-last-name-wrap input").val();
                _give_payment_gateway = $("input[name='give-gateway']").val() + " " + give_recurring_modal_period;
                _give_payment_price_id = "0";
                _give_payment_donor_email = $("#give-email-wrap input").val();
                _give_payment_mode = "live";
                _give_current_url = window.location.origin + "/colabora/";
                _give_current_page_id = "867";
                _give_tributes_accept = "";
                certificado_de_donacin = (cert) ? "SÍ" : "NO" ;
                cif = $("#cif-wrap input").val();
                sociocity = $("#sociocity-wrap input").val();
                donantesurname = $("#donantesurname-wrap input").val();
                _give_form_fields_id = "";
                _give_payment_form_title = "";
                payment_bt_complete_name = $("#account-tit-name").val();
                payment_bt_iban = $("#account-tit-ib-iban").val();
                payment_bt_entidad = $("#account-tit-ib-entidad").val();
                payment_bt_oficina = $("#account-tit-ib-oficina").val();
                payment_bt_control = $("#account-tit-ib-control").val();
                payment_bt_cuenta = $("#account-tit-ib-cuenta").val();
                _give_form_fields_id = "669";
                _give_payment_form_title = "Socio empresa";
                _give_current_url += "socios/empresa/";

                $.ajax({
                   url: window.location.origin + '/wp-json/api/v1/bankpayment/',
                   type: "POST",
                   data: {
                      tipo_user: user,
                      tipo_medio: type,
                      _give_payment_total: _give_payment_total,
                      _give_payment_currency: _give_payment_currency,
                      _give_donor_billing_first_name: _give_donor_billing_first_name,
                      _give_donor_billing_last_name: _give_donor_billing_last_name,
                      _give_payment_gateway: _give_payment_gateway,
                      _give_payment_form_title: _give_payment_form_title,
                      _give_payment_form_id: _give_form_fields_id,
                      _give_payment_price_id: _give_payment_price_id,
                      _give_payment_donor_email: _give_payment_donor_email,
                      _give_payment_mode: _give_payment_mode,
                      _give_current_url: _give_current_url,
                      _give_current_page_id: _give_current_page_id,
                      _give_tributes_accept: _give_tributes_accept,
                      donantetipodonacion: donantetipodonacion,
                      certificado_de_donacin: certificado_de_donacin,
                      cif: cif,
                      sociophone: sociophone,
                      sociotipovia: sociotipovia,
                      socioaddress: socioaddress,
                      sociopopulation: sociopopulation,
                      sociozipcode: sociozipcode,
                      donantesurname: donantesurname,
                      sociocity: sociocity,
                      sociocountry: sociocountry,
                      socio_haveknown: socio_haveknown,
                      socio_haveknown_otro: socio_haveknown_otro,
                      perfil: perfil,
                      _give_form_fields_id: _give_form_fields_id,
                      payment_bt_complete_name: payment_bt_complete_name,
                      payment_bt_iban: payment_bt_iban,
                      payment_bt_entidad: payment_bt_entidad,
                      payment_bt_oficina: payment_bt_oficina,
                      payment_bt_control: payment_bt_control,
                      payment_bt_cuenta: payment_bt_cuenta,
                      lang: languageUsed
                   },
                   error: function() {
                        showAjaxError();
                   },
                   success: function(data) {
                        if (languageUsed === "es-ES")
                        {
                            location.href = window.location.origin + "/colabora/confirmacion-de-donacion/";
                        }
                        if (languageUsed === "en-US")
                        {
                            location.href = window.location.origin + "/get-involved/donation-confirmation/";
                        }
                   }
                });
            }

            if ((user === 'donante') && (type === "particular"))
            {
                donantedni = $("#donantedni-wrap input").val();
                donantebirthday = $("#donantebirthday-wrap input").val();
                donanteaddress = $("#donanteaddress-wrap input").val();
                sociopopulation = $("#sociopopulation-wrap input").val();
                sociozipcode = $("#sociozipcode-wrap input").val();
                donante_country = $("#donante_country-wrap input").val();
                donante_haveknown = $("#ffm-donante_haveknown input:checked").val();
                donante_haveknown_otro = $("#ffm-donante_haveknown_otro").val();
                donantephone = $("#donantephone-wrap select option:selected").text() + $("#donantephone-wrap input").val();
                donanteroadtype = $("#donanteroadtype-wrap select option:selected").text();
                donantetipodonacion = (anonim) ? "Deseo que mi donación sea anónima" : "No tengo problema en facilitar mis datos" ;
                give_recurring_modal_period = "";
                _give_payment_total = $(".give-final-total-amount").html().trim().replace("€","");
                _give_payment_currency = "EUR";
                _give_donor_billing_first_name = $("#give-first-name-wrap input").val();
                _give_donor_billing_last_name = $("#give-last-name-wrap input").val();
                _give_payment_gateway = $("input[name='give-gateway']").val() + " " + give_recurring_modal_period;
                _give_payment_price_id = "0";
                _give_payment_donor_email = $("#give-email-wrap input").val();
                _give_payment_mode = "live";
                _give_current_url = window.location.origin + "/colabora/";
                _give_current_page_id = "867";
                _give_tributes_accept = "";
                certificado_de_donacin = (cert) ? "SÍ" : "NO" ;
                donantelastname = $("#give-last-name-wrap input").val();
                donantecity = $("#donantecity-wrap input").val();
                _give_form_fields_id = "";
                _give_payment_form_title = "";
                payment_bt_complete_name = $("#account-tit-name").val();
                payment_bt_iban = $("#account-tit-ib-iban").val();
                payment_bt_entidad = $("#account-tit-ib-entidad").val();
                payment_bt_oficina = $("#account-tit-ib-oficina").val();
                payment_bt_control = $("#account-tit-ib-control").val();
                payment_bt_cuenta = $("#account-tit-ib-cuenta").val();
                _give_form_fields_id = "670";
                _give_payment_form_title = "Donante particular";
                _give_current_url += "donantes/particular/";

                $.ajax({
                   url: window.location.origin + '/wp-json/api/v1/bankpayment/',
                   type: "POST",
                   data: {
                      tipo_user: user,
                      tipo_medio: type,
                      _give_payment_total: _give_payment_total,
                      _give_payment_currency: _give_payment_currency,
                      _give_donor_billing_first_name: _give_donor_billing_first_name,
                      _give_donor_billing_last_name: _give_donor_billing_last_name,
                      _give_payment_gateway: _give_payment_gateway,
                      _give_payment_form_title: _give_payment_form_title,
                      _give_payment_form_id: _give_form_fields_id,
                      _give_payment_price_id: _give_payment_price_id,
                      _give_payment_donor_email: _give_payment_donor_email,
                      _give_payment_mode: _give_payment_mode,
                      _give_current_url: _give_current_url,
                      _give_current_page_id: _give_current_page_id,
                      _give_tributes_accept: _give_tributes_accept,
                      donantetipodonacion: donantetipodonacion,
                      certificado_de_donacin: certificado_de_donacin,
                      donantelastname: donantelastname,
                      donantephone: donantephone,
                      donantedni: donantedni,
                      donantebirthday: donantebirthday,
                      donanteroadtype: donanteroadtype,
                      donanteaddress: donanteaddress,
                      sociopopulation: sociopopulation,
                      sociozipcode: sociozipcode,
                      donantecity: donantecity,
                      donante_country: donante_country,
                      donante_haveknown: donante_haveknown,
                      donante_haveknown_otro: donante_haveknown_otro,
                      perfil: perfil,
                      _give_form_fields_id: _give_form_fields_id,
                      payment_bt_complete_name: payment_bt_complete_name,
                      payment_bt_iban: payment_bt_iban,
                      payment_bt_entidad: payment_bt_entidad,
                      payment_bt_oficina: payment_bt_oficina,
                      payment_bt_control: payment_bt_control,
                      payment_bt_cuenta: payment_bt_cuenta,
                      project_destiny_ref: project_destiny_ref,
                      project_destiny_post_id: project_destiny_post_id,
                      project_destiny_name: project_destiny_name,
                      lang: languageUsed
                   },
                   error: function() {
                        showAjaxError();
                   },
                   success: function(data) {

                        if (languageUsed === "es-ES")
                        {
                            if (isDonationForProject())
                            {
                                location.href = window.location.origin + "/colabora/confirmacion-de-donacion/?r=project";
                            }
                            else
                            {
                                location.href = window.location.origin + "/colabora/confirmacion-de-donacion/";
                            }
                        }
                        if (languageUsed === "en-US")
                        {
                            if (isDonationForProject())
                            {
                                location.href = window.location.origin + "/get-involved/donation-confirmation/?r=project";
                            }
                            else
                            {
                                location.href = window.location.origin + "/get-involved/donation-confirmation/";
                            }
                        }
                        
                   }
                });

            }

            if ((user === 'donante') && (type === "empresa"))
            {
                donanteaddress = $("#donanteaddress-wrap input").val();
                donantepopulation = $("#donantepopulation-wrap input").val();
                donantezipcode = $("#donantezipcode-wrap input").val();
                donantecountry = $("#donantecountry-wrap input").val();
                cif = $("#cif-wrap input").val();
                donante_haveknown = $("#ffm-donante_haveknown input:checked").val();
                donante_haveknown_otro = $("#ffm-donante_haveknown_otro").val();
                donantesurname = $("#donantesurname-wrap input").val();
                donantephone = $("#donantephone-wrap select option:selected").text() + $("#donantephone-wrap input").val();
                donanteroadtype = $("#donanteroadtype-wrap select option:selected").text();
                donantetipodonacion = (anonim) ? "Deseo que mi donación sea anónima" : "No tengo problema en facilitar mis datos" ;
                give_recurring_modal_period = "";
                _give_payment_total = $(".give-final-total-amount").html().trim().replace("€","");
                _give_payment_currency = "EUR";
                _give_donor_billing_first_name = $("#give-first-name-wrap input").val();
                _give_donor_billing_last_name = $("#give-last-name-wrap input").val();
                _give_payment_gateway = $("input[name='give-gateway']").val() + " " + give_recurring_modal_period;
                _give_payment_price_id = "0";
                _give_payment_donor_email = $("#give-email-wrap input").val();
                _give_payment_mode = "live";
                _give_current_url = window.location.origin + "/colabora/";
                _give_current_page_id = "867";
                _give_tributes_accept = "";
                certificado_de_donacin = (cert) ? "SÍ" : "NO" ;
                donantelastname = $("#give-last-name-wrap input").val();
                donantecity = $("#donantecity-wrap input").val();
                _give_form_fields_id = "";
                _give_payment_form_title = "";
                payment_bt_complete_name = $("#account-tit-name").val();
                payment_bt_iban = $("#account-tit-ib-iban").val();
                payment_bt_entidad = $("#account-tit-ib-entidad").val();
                payment_bt_oficina = $("#account-tit-ib-oficina").val();
                payment_bt_control = $("#account-tit-ib-control").val();
                payment_bt_cuenta = $("#account-tit-ib-cuenta").val();
                _give_form_fields_id = "671";
                _give_payment_form_title = "Donante empresa";
                _give_current_url += "donantes/empresa/";

                $.ajax({
                   url: window.location.origin + '/wp-json/api/v1/bankpayment/',
                   type: "POST",
                   data: {
                      tipo_user: user,
                      tipo_medio: type,
                      _give_payment_total: _give_payment_total,
                      _give_payment_currency: _give_payment_currency,
                      _give_donor_billing_first_name: _give_donor_billing_first_name,
                      _give_donor_billing_last_name: _give_donor_billing_last_name,
                      _give_payment_gateway: _give_payment_gateway,
                      _give_payment_form_title: _give_payment_form_title,
                      _give_payment_form_id: _give_form_fields_id,
                      _give_payment_price_id: _give_payment_price_id,
                      _give_payment_donor_email: _give_payment_donor_email,
                      _give_payment_mode: _give_payment_mode,
                      _give_current_url: _give_current_url,
                      _give_current_page_id: _give_current_page_id,
                      _give_tributes_accept: _give_tributes_accept,
                      donantetipodonacion: donantetipodonacion,
                      certificado_de_donacin: certificado_de_donacin,
                      donantelastname: donantelastname,
                      donantesurname: donantesurname,
                      cif: cif,
                      donantephone: donantephone,
                      donanteroadtype: donanteroadtype,
                      donanteaddress: donanteaddress,
                      donantepopulation: donantepopulation,
                      donantezipcode: donantezipcode,
                      donantecity: donantecity,
                      donantecountry: donantecountry,
                      donante_haveknown: donante_haveknown,
                      donante_haveknown_otro: donante_haveknown_otro,
                      perfil: perfil,
                      _give_form_fields_id: _give_form_fields_id,
                      payment_bt_complete_name: payment_bt_complete_name,
                      payment_bt_iban: payment_bt_iban,
                      payment_bt_entidad: payment_bt_entidad,
                      payment_bt_oficina: payment_bt_oficina,
                      payment_bt_control: payment_bt_control,
                      payment_bt_cuenta: payment_bt_cuenta,
                      project_destiny_ref: project_destiny_ref,
                      project_destiny_post_id: project_destiny_post_id,
                      project_destiny_name: project_destiny_name,
                      lang: languageUsed
                   },
                   error: function() {
                        showAjaxError();
                   },
                   success: function(data) {

                        if (languageUsed === "es-ES")
                        {
                            if (isDonationForProject())
                            {
                                location.href = window.location.origin + "/colabora/confirmacion-de-donacion/?r=project";
                            }
                            else
                            {
                                location.href = window.location.origin + "/colabora/confirmacion-de-donacion/";
                            }
                        }
                        if (languageUsed === "en-US")
                        {
                            if (isDonationForProject())
                            {
                                location.href = window.location.origin + "/get-involved/donation-confirmation/?r=project";
                            }
                            else
                            {
                                location.href = window.location.origin + "/get-involved/donation-confirmation/";
                            }
                        }
                   }
                });

            }
        }
    }

    document.addEventListener('DOMContentLoaded', prepareValidation);

    $('.js-date').on('click keypress keydown dblclick', function(){
        var inputDate = this;
        var inputDateY = $(inputDate).offset().top;
        var currentYi = $('#ui-datepicker-div').offset().top;
        const heightIntput = 50 ;
        var tranlateM =  currentYi - inputDateY - heightIntput;

        $('#ui-datepicker-div').css({
            marginTop: -tranlateM + 'px'}
        );
    });

    $.datepicker.setDefaults({
        changeMonth: true,
        changeYear: true,
        yearRange: "-100:+0",
        defaultDate: "+1m +7d"
    });

    $("#give-payment-mode-select").hide();

    var html_metodo_pago_socios, html_metodo_pago_donantes;

    if (languageUsed === "es-ES")
    {
        html_metodo_pago_socios = "<label class='give-label'>Método de pago</label><span id='ffm-metodo-pago' class='ffm-fields ffm-radio-field'><label><input class='radiofield' id='radio_metodopago_stripe' name='metodopago' type='radio' value='stripe' checked='checked'>Tarjeta de crédito</label><label><input class='radiofield' id='radio_metodopago_paypal' name='metodopago' type='radio' value='paypal'>Paypal</label><label><input class='radiofield' id='radio_metodopago_transfer' name='metodopago' type='radio' checked='checked' value='transfer'>Domiciliación Bancaria</label></span><input type='hidden' id='payment-method' value='stripe'/><input type='hidden' id='payment-step' value='1'/><input type='hidden' id='anonim-data' value='false'/><br/>";

        html_metodo_pago_donantes = "<label class='give-label'>Método de pago</label><span id='ffm-metodo-pago' class='ffm-fields ffm-radio-field'><label><input class='radiofield' id='radio_metodopago_stripe' name='metodopago' type='radio' value='stripe' checked='checked'>Tarjeta de crédito</label><label><input class='radiofield' id='radio_metodopago_paypal' name='metodopago' type='radio' value='paypal'>Paypal</label><label><input class='radiofield' name='metodopago' id='radio_metodopago_transfer' type='radio' value='transfer'>Domiciliación Bancaria</label></span><input type='hidden' id='payment-method' value='stripe'/><input type='hidden' id='payment-step' value='1'/><input type='hidden' id='anonim-data' value='false'/><br/>";
    }
    if (languageUsed === "en-US")
    {
        html_metodo_pago_socios = "<label class='give-label'>Payment method</label><span id='ffm-metodo-pago' class='ffm-fields ffm-radio-field'><label><input class='radiofield' id='radio_metodopago_stripe' name='metodopago' type='radio' value='stripe' checked='checked'>Credit card</label><label><input class='radiofield' id='radio_metodopago_paypal' name='metodopago' type='radio' value='paypal'>Paypal</label><label><input class='radiofield' id='radio_metodopago_transfer' name='metodopago' type='radio' checked='checked' value='transfer'>Bank Domiciliation</label></span><input type='hidden' id='payment-method' value='stripe'/><input type='hidden' id='payment-step' value='1'/><input type='hidden' id='anonim-data' value='false'/><br/>";

        html_metodo_pago_donantes = "<label class='give-label'>Payment method</label><span id='ffm-metodo-pago' class='ffm-fields ffm-radio-field'><label><input class='radiofield' id='radio_metodopago_stripe' name='metodopago' type='radio' value='stripe' checked='checked'>Credit card</label><label><input class='radiofield' id='radio_metodopago_paypal' name='metodopago' type='radio' value='paypal'>Paypal</label><label><input class='radiofield' name='metodopago' id='radio_metodopago_transfer' type='radio' value='transfer'>Bank Domiciliation</label></span><input type='hidden' id='payment-method' value='stripe'/><input type='hidden' id='payment-step' value='1'/><input type='hidden' id='anonim-data' value='false'/><br/>";
    }

    $("#sociocert-wrap").prepend(html_metodo_pago_socios);
    $("#donantetipodonacion-wrap").prepend(html_metodo_pago_donantes);

    $("input[name='metodopago']").on('click', function(){

        enableAnonimDonation();

        payment_method = "stripe";
        if ($("#radio_metodopago_transfer").is(':checked')) {
            payment_method = "transfer";
        }
        if ($("#radio_metodopago_paypal").is(':checked')) {
            payment_method = "paypal";
            disableAnonimDonation();
        }

        $("#payment-method").val(payment_method);

        $("#payment-step").val(2);
    });

    function validate_titular_name()
    {
        var data = $("#account-tit-name").val().trim();
        if (!/^([[0-9A-Za-zÁÉÍÓÚÑ \-'&,._áéíóúñüÜ]){3,40}$/.test(data))
        {
            return false;
        }
        return true;
    }

    function validate_account_number_iban()
    {
        var data = $("#account-tit-ib-iban").val().trim();
        if (!/^[a-zA-Z]{2}[0-9]{2}$/.test(data))
        {
            return false;
        }
        return true;
    }

    function validate_account_number_entidad()
    {
        var data = $("#account-tit-ib-entidad").val().trim();
        if (!/^[0-9]{4}$/.test(data))
        {
            return false;
        }
        return true;
    }

    function validate_account_number_oficina()
    {
        var data = $("#account-tit-ib-oficina").val().trim();
        if (!/^[0-9]{4}$/.test(data))
        {
            return false;
        }
        return true;
    }

    function validate_account_number_control()
    {
        var data = $("#account-tit-ib-control").val().trim();
        if (!/^[0-9]{2}$/.test(data))
        {
            return false;
        }
        return true;
    }

    function validate_account_number_cuenta()
    {
        var data = $("#account-tit-ib-cuenta").val().trim();
        if (!/^[0-9]{10}$/.test(data))
        {
            return false;
        }
        return true;
    }

    function validate_agree_to_terms()
    {
        if (!$("input[name='give_agree_to_terms']").is(":checked"))
        {
            return false;
        }
        return true;
    }

    function translateAllCustomCharacteresChainsStep2()
    {
        $('#ffm-socio_haveknown').html('<label><input class="radiofield" data-required="no" name="socio_haveknown" type="radio" value="Amigo o familiar" data-value="Amigo o familiar">Friend or family</label><label><input class="radiofield" data-required="no" name="socio_haveknown" type="radio" value="Internet" data-value="Internet">Internet</label><label><input class="radiofield" data-required="no" name="socio_haveknown" type="radio" value="Medios de comunicación">Media</label><label><input class="radiofield" data-required="no" name="socio_haveknown" type="radio" value="A través de mi empresa" data-value="A través de mi empresa">By my company</label><label><input class="radiofield" data-required="no" name="socio_haveknown" type="radio" value="Campaña publicitaria">Advertising campaign</label><label><input class="radiofield" data-required="no" name="socio_haveknown" type="radio" value="Evento">Event</label><label><input class="radiofield" data-required="no" name="socio_haveknown" type="radio" value="A través de un colaborador de CODESPA">By CODESPA colaborator</label><label><input class="radiofield" data-required="no" name="socio_haveknown" type="radio" value="Otros">Other</label>');
        $('#ffm-form_helpout_howmet').html('<label><input class="radiofield" data-required="no" name="form_helpout_howmet" type="radio" value="Amigo o familiar" data-value="Amigo o familiar">Friend or family</label><label><input class="radiofield" data-required="no" name="form_helpout_howmet" type="radio" value="Internet" data-value="Internet">Internet</label><label><input class="radiofield" data-required="no" name="form_helpout_howmet" type="radio" value="Medios de comunicación" data-value="Medios de comunicación">Media</label><label><input class="radiofield" data-required="no" name="form_helpout_howmet" type="radio" value="A través de mi empresa" data-value="A través de mi empresa">By my company</label><label><input class="radiofield" data-required="no" name="form_helpout_howmet" type="radio" value="Campaña publicitaria" data-value="Campaña publicitaria">Advertising campaign</label><label><input class="radiofield" data-required="no" name="form_helpout_howmet" type="radio" value="Evento" data-value="Evento">Event</label><label><input class="radiofield" data-required="no" name="form_helpout_howmet" type="radio" value="A través de un colaborador de CODESPA" data-value="A través de un colaborador de CODESPA">By CODESPA colaborator</label><label><input class="radiofield" data-required="no" name="form_helpout_howmet" type="radio" value="Otros" data-value="Otros">Others</label>');
        $('#ffm-donante_haveknown').html('<label><input class="radiofield" data-required="no" name="donante_haveknown" type="radio" value="Amigo o familiar" data-value="Amigo o familiar">Friend or family</label><label><input class="radiofield" data-required="no" name="donante_haveknown" type="radio" value="Internet">Internet</label><label><input class="radiofield" data-required="no" name="donante_haveknown" type="radio" value="Medios de comunicación">Media</label><label><input class="radiofield" data-required="no" name="donante_haveknown" type="radio" value="A través de mi empresa" data-value="A través de mi empresa">By my company</label><label><input class="radiofield" data-required="no" name="donante_haveknown" type="radio" value="Campaña publicitaria">Advertising campaign</label><label><input class="radiofield" data-required="no" name="donante_haveknown" type="radio" value="Evento">Event</label><label><input class="radiofield" data-required="no" name="donante_haveknown" type="radio" value="A través de un colaborador de CODESPA">By CODESPA colaborator</label><label><input class="radiofield" data-required="no" name="donante_haveknown" type="radio" value="Otros">Others</label>');
    }

    $("#give-purchase-button").on('touchstart click', function(e){

        var user;
        var type;

        var perfil = $("input[name='perfil']").val();
        if (typeof(perfil) === "undefined")
        {
            return;
        }

        var perfil_arr = perfil.split("-");
        user = perfil_arr[0];
        type = perfil_arr[1];

        if (type === "empresa")
        {
            if (languageUsed === "es-ES")
            {
                $('#give-last-name-wrap input').val("Empresa");
            }
            if (languageUsed === "en-US")
            {
                $('#give-last-name-wrap input').val("Company");
            }
        }

        if (isBankTransfer())
        {
            var errors = [];

            if (!validate_titular_name())
            {
                if (languageUsed === "es-ES")
                {
                    addTitularNameErrorLabel("CAMPO OBLIGATORIO");
                }
                if (languageUsed === "en-US")
                {
                    addTitularNameErrorLabel("OBLIGATORY FIELD");
                }
                errors.push("titular_name");
            }
            else
            {
                removeTitularNameErrorLabel();
            }

            if ((!validate_account_number_iban()) || (!validate_account_number_entidad()) || (!validate_account_number_oficina()) || (!validate_account_number_control()) || (!validate_account_number_cuenta()))
            {
                if (languageUsed === "es-ES")
                {
                    addAccountNumberIbanErrorLabel("La cuenta bancaria no es correcta. El formato debe ser: IBAN (ESXX) + Nº de cuenta bancaria (XXXX XXXX XX XXXXXXXXXX)");
                }
                if (languageUsed === "en-US")
                {
                    addAccountNumberIbanErrorLabel("The bank account is not correct. The format should be: IBAN (ESXX) + Bank account number (XXXX XXXX XX XXXXXXXXXX)");
                }
                errors.push("account_number");
            }
            else
            {
                removeAccountNumberIbanErrorLabel();
            }

            if (!validate_agree_to_terms())
            {
                if (languageUsed === "es-ES")
                {
                    addAgreeTermsErrorLabel("Debe aceptar la Política de Protección de datos");
                }
                if (languageUsed === "en-US")
                {
                    addAgreeTermsErrorLabel("You must accept the Data Protection Policy");
                }
                errors.push("AgreeTerms");
            }
            else
            {
                removeAgreeTermsErrorLabel();
            }

            if (errors.length > 0)
            {
                errors = [];
                moveToTop();
                return false;
            }

            disablePayButton();
            $(".give-loading-animation").show();

            // Success a Transfer by Bank account !!

            payBankTransfer();
        }

        var anonim = false;
        var payment_method = "stripe";
        if (user === "donante")
        {
            anonim = ($('#ffm-donantetipodonacion input:radio').first().is(':checked'));
            if ($("#radio_metodopago_transfer").is(':checked')) {
                payment_method = "transfer";
            }
            if ($("#radio_metodopago_paypal").is(':checked')) {
                payment_method = "paypal";
            }
        }
        else
        {
            payment_method = "transfer";
        }

        if (anonim)
        {
            ga('send', 'event', 'Donaciones', 'Formulario_donaciones', 'Paso_3_' + user + '_' + type + '_usuarioAnonimo_' + payment_method);
        }
        else
        {
            ga('send', 'event', 'Donaciones', 'Formulario_donaciones', 'Paso_3_' + user + '_' + type + '_usuario_' + payment_method);
        }

        if (!isBankTransfer() && isDonationForProject() && (user === 'donante'))
        {
            saveProjectDonationPossible();
        }

    });

    function gotoStep2()
    {
        removeTitularNameErrorLabel();
        removeAccountNumberIbanErrorLabel();
        removeAgreeTermsErrorLabel();

        $("#payment-step").val(2);

        var perfil = $("input[name='perfil']").val();
        if (typeof(perfil) !== "undefined")
        {
            var perfil_arr = perfil.split("-");
            var user = perfil_arr[0];
            var anonim = false;
            if (user === "donante")
            {
                anonim = ($('#ffm-donantetipodonacion input:radio').first().is(':checked'));
            }

            if (perfil_arr[0] === 'socio')
            {
                $(".give-recurring-multi-level-message").hide();
                clearInterval(textIntervalSummary);
                $(".give-recurring-multi-level-message-es").hide();
            }

            if (anonim)
            {
                resetNumberColors();
                $("div[data-linestep=1]").addClass("linestep-selected");
                $("div[data-linestep=2]").addClass("linestep-noselected");
                $("div[data-linestep=3]").addClass("linestep-noselected");
            }
            else
            {
                resetNumberColors();
                $("div[data-linestep=1]").addClass("linestep-selected");
                $("div[data-linestep=2]").addClass("linestep-selected");
                $("div[data-linestep=3]").addClass("linestep-noselected");
            }

            $("#give_purchase_form_bank_account").remove();
        }
    }

    $(".backStep1").on('click', function(){

        gotoStep1();
        moveToTop();

        if (isMobile())
        {
            $("#give_purchase_form_wrap").hide();
        }

        var perfil = $("input[name='perfil']").val();
        if (typeof(perfil) !== "undefined")
        {
            var perfil_arr = perfil.split("-");

            if (perfil_arr[0] === 'socio')
            {
                $(".give-recurring-multi-level-message").show();
                $(".give-recurring-multi-level-message-es").show();
            }
        }

    });
    $(".backStep2").on('click', function(){

        gotoStep2();
        moveToTop();

        if (isMobile())
        {
            $("#give_purchase_form_wrap").hide();
        }

    });

    $("div.step1_c").on('click', function(){

        var perfil = $("input[name='perfil']").val();
        var perfil_arr;

        showAllFormInputsWithGoodFeeling();

        if (isMobile())
        {
            $("#give_purchase_form_wrap").show();
        }

        payment_method = "stripe";
        if ($("#radio_metodopago_transfer").is(':checked')) {
            payment_method = "transfer";
        }
        if ($("#radio_metodopago_paypal").is(':checked')) {
            payment_method = "paypal";
        }

        $("#payment-method").val(payment_method);

        if (isAnonimDonation())
        {
            resetNumberColors();
            $("div[data-linestep=1]").addClass("linestep-selected");
            $("div[data-linestep=2]").addClass("linestep-selected");
            $("div[data-linestep=3]").addClass("linestep-selected");

            fillFieldsIfAnonim();

            if (typeof(perfil) !== "undefined")
            {
                perfil_arr = perfil.split("-");
                ga('send', 'event', 'Donaciones', 'Formulario_donaciones', 'Paso_1_' + perfil_arr[0] + '_' + perfil_arr[1] + '_usuarioAnonimo_' + payment_method);
            }

            goToPayment();
        }
        else
        {
            resetNumberColors();
            $("div[data-linestep=1]").addClass("linestep-selected");
            $("div[data-linestep=2]").addClass("linestep-selected");
            $("div[data-linestep=3]").addClass("linestep-noselected");

            if (typeof(perfil) !== "undefined")
            {
                perfil_arr = perfil.split("-");
                ga('send', 'event', 'Donaciones', 'Formulario_donaciones', 'Paso_1_' + perfil_arr[0] + '_' + perfil_arr[1] + '_usuario_' + payment_method);
            }

            resetFieldsIfNotAnonim();
        }

        if (typeof(perfil) !== "undefined")
        {
            perfil_arr = perfil.split("-");

            var cert = false;
            if (perfil_arr[0] === 'socio')
            {
                cert = ($('#ffm-sociocert input:radio').first().is(':checked'));
                $(".give-recurring-multi-level-message").hide();
                clearInterval(textIntervalSummary);
                $(".give-recurring-multi-level-message-es").hide();
            }
            else
            {
                cert = ($('#certificado_de_donacin-wrap input:radio').first().is(':checked'));
            }

            configureRequiredFields(perfil_arr[0], perfil_arr[1], cert);

            moveToTop();
        }

        if (languageUsed === "en-US")
        {
            // Por algún motivo no se pueden crear Custom fields en los formularios de ingles, asi que habrá que traducir a pelo todo lo que quede por traducir
            translateAllCustomCharacteresChainsStep2();
        }
    });

    function addCustomChangesInRecurrentDonationsForm()
    {
        var perfil = $("input[name='perfil']").val();
        if (typeof(perfil) === "undefined")
        {
            return;
        }

        var perfil_arr = perfil.split("-");

        if (perfil_arr[0] !== 'socio')
        {
            return;
        }

        var type = perfil_arr[1];
        var type_form = (type === 'particular') ? "668" : "669" ;

        if (languageUsed === "es-ES")
        {
            $('#give-donation-level-select-'+type_form).before("<span class='text-title-soc-exp'>Decide la periodicidad de tu donación<br>(recuerda que la frecuencia es la última que hayas seleccionado)</span><br>");
            $('input#give-amount').before("<br><span class='text-title-soc-exp'>Si lo deseas, personaliza tu cantidad a donar:</span><br><br>");
        }
        if (languageUsed === "en-US")
        {
            $('#give-donation-level-select-'+type_form).before("<span class='text-title-soc-exp'>Tell us the periodicity of your donation<br>(remember that the frequency is the last one you have selected)</span><br>");
            $('input#give-amount').before("<br><span class='text-title-soc-exp'>If you wish, customize your donation amount:</span><br><br>");
        }
    }

    function translateOneFormField(tag, tx)
    {
        $('#' + tag + ' input').attr("placeholder",tx);
        $('#' + tag + ' label').attr("text",tx);
        $('#' + tag + ' label').html(tx);
    }

    function translateAllCustomCharacteresChains()
    {
        var tag;

        $(".give-label[for=ffm-sociocert]").html("Donation certificate");
        $(".give-label[for=ffm-certificado_de_donacin]").html("Donation certificate");

        $(".give-label[for=ffm-donantetipodonacion]").html("Type of donation");

        $("#ffm_html-wrap small").html("If you leave us your personal information, you can deduct 75% of the first 150 € donated. From this amount, donations will be deductible at 30% or at 35% if it is a matter of periodic donations made during at least three years (this certificate is only valid in Spain)");

        translateOneFormField("sociophone-wrap", "Phone");
        translateOneFormField("sociodni-wrap", "DNI (Ex.: 00000001X)");
        translateOneFormField("sociobirthday-wrap", "Birthday date");
        translateOneFormField("sociotipovia-wrap", "Type of road");
        translateOneFormField("socioaddress-wrap", "Complete address");
        translateOneFormField("poblacin-wrap", "Population");
        translateOneFormField("cp-wrap", "Zip code");
        translateOneFormField("donantecity-wrap", "City");
        translateOneFormField("donantecountry-wrap", "Country");
        translateOneFormField("sociolastname-wrap", "Second surname");

        translateOneFormField("donantesurname-wrap", "Contact person");
        translateOneFormField("sociopopulation-wrap", "Population");
        translateOneFormField("sociocity-wrap", "City");
        translateOneFormField("sociozipcode-wrap", "Zip code");
        translateOneFormField("sociocountry-wrap", "Country");

        translateOneFormField("donantelastname-wrap", "Second surname");
        translateOneFormField("donantephone-wrap", "Phone");
        translateOneFormField("donantedni-wrap", "DNI (Ex.: 00000001X)");
        translateOneFormField("donantebirthday-wrap", "Birthday date");
        translateOneFormField("donanteroadtype-wrap", "Type of road");
        translateOneFormField("donanteaddress-wrap", "Complete address");
        translateOneFormField("sociopopulation-wrap", "Population");
        translateOneFormField("sociozipcode-wrap", "Zip code");
        translateOneFormField("donante_country-wrap", "Country");

        translateOneFormField("donantepopulation-wrap", "Population");
        translateOneFormField("donantezipcode-wrap", "Zip code");

        $('#donante_haveknown_otro-wrap textarea').attr("placeholder","How did you know us?");
        $('#donante_haveknown_otro-wrap label').attr("text","How did you know us?");
        $('#donante_haveknown_otro-wrap label').html("How did you know us?");

        $('#socio_haveknown_otro-wrap textarea').attr("placeholder","How did you know us?");
        $('#socio_haveknown_otro-wrap label').attr("text","How did you know us?");
        $('#socio_haveknown_otro-wrap label').html("How did you know us?");

        $('#ffm-donantetipodonacion').html('<label><input class="radiofield" data-required="no" name="donantetipodonacion" type="radio" value="Deseo que mi donación sea anónima">I want to be anonymous</label><label><input class="radiofield" data-required="no" name="donantetipodonacion" type="radio" value="No tengo problema en facilitar mis datos" checked="checked">I have no problem in providing my data</label>');
            
        $('input[name=donantetipodonacion]').first().on('click', setAnonimDonation);
        $('input[name=donantetipodonacion]').last().on('click', setNoAnonimDonation);

        $('#ffm-certificado_de_donacin').html('<label><input class="radiofield" data-required="no" name="certificado_de_donacin" type="radio" value="SÍ">YES</label><label><input class="radiofield" data-required="no" name="certificado_de_donacin" type="radio" value="NO" checked="checked">NO</label>');
        $('#ffm-sociocert').html('<label><input class="radiofield" data-required="no" name="sociocert" type="radio" value="SÍ">YES</label><label><input class="radiofield" data-required="no" name="sociocert" type="radio" value="NO" checked="checked">NO</label>');

        $('select#give-donation-level-select-668 option.give-donation-level-custom').text("Other amounts");
        $('select#give-donation-level-select-669 option.give-donation-level-custom').text("Other amounts");

        $('.give-btn-level-custom').text("Other");

        tag = $('#form_helpout_howmet-wrap').html();
        if (typeof(tag) !== "undefined")
        {
            tag = tag.replace(/Cómo nos has conocido \(Opcional\)/g, "How did you know us (Optional)");
            $('#form_helpout_howmet-wrap').html(tag);
        }        
        tag = $('#socio_haveknown-wrap').html();
        if (typeof(tag) !== "undefined")
        {
            tag = tag.replace(/Cómo nos has conocido \(Opcional\)/g, "How did you know us (Optional)");
            $('#socio_haveknown-wrap').html(tag);
        }
        tag = $('#donante_haveknown-wrap').html();
        if (typeof(tag) !== "undefined")
        {
            tag = tag.replace(/Cómo nos has conocido \(Opcional\)/g, "How did you know us (Optional)");
            $('#donante_haveknown-wrap').html(tag);
        }

        $('div.swichProfile div.optionA label').text("I'm individual");
        $('div.swichProfile div.optionB label').text("I'm a company");
    }

    $('input[name=donantetipodonacion]').first().on('click', setAnonimDonation);
    $('input[name=donantetipodonacion]').last().on('click', setNoAnonimDonation);

    $('#socio_prefix').change(function() {
      var seleccion = $(this).val();
      $("#socio_prefix option").first().text("+"+seleccion);
    });
    $('#ffm-donanteroadtype').change(function() {
      var seleccion = $(this).val();
      $("#ffm-donanteroadtype option").first().text(seleccion);
    });
    $('#ffm-sociotipovia').change(function() {
      var seleccion = $(this).val();
      $("#ffm-sociotipovia option").first().text(seleccion);
    });

    checkIfReloadPageInsideForm();
 
    getPreviousDonationParameter();
    getProjectRefDonationParameter();

    replaceTagsOfRecurringDonations();
    replaceSummaryOfRecurringDonations();

    addCustomChangesInRecurrentDonationsForm();

    if (languageUsed === "en-US")
    {
        // Por algún motivo no se pueden crear Custom fields en los formularios de ingles, asi que habrá que traducir a pelo todo lo que quede por traducir
        translateAllCustomCharacteresChains();
    }

})(jQuery);
